/* HM-Enhancements v13 - P1 build 1787687212 */
/* Harvest Market Enhancement System v2.0 - JavaScript */
/* 200+ client-side features */
(function() {
  'use strict';

  var HM = window.HM || {};
  window.HM = HM;

  /* ============================================
     1. FREE SHIPPING ANNOUNCEMENT BAR
     ============================================ */
  HM.injectAnnouncementBar = function() {
    var bar = document.createElement('div');
    bar.className = 'hm-announcement';
    bar.innerHTML = 'Free shipping on orders over $50 &middot; <a href="/collections/roasted-coffee">Shop Coffee</a> &middot; <a href="/pages/about-us">Our Story</a>';
    var header = document.querySelector('.shopify-section-group-header-group');
    if (header && header.parentNode) {
      header.parentNode.insertBefore(bar, header);
    }
  };

  /* ============================================
     2. TRUST BAR (below hero carousel)
     ============================================ */
  HM.injectTrustBar = function() {
    var hero = document.getElementById('heroCarousel') || document.querySelector('.hero-multi-brand');
    if (!hero) return;
    var bar = document.createElement('div');
    bar.className = 'hm-trust-bar';
    bar.innerHTML = [
      '<div class="hm-trust-item"><svg viewBox="0 0 24 24"><path d="M12 2L4 5v6c0 5.5 3.8 10.7 8 12 4.2-1.3 8-6.5 8-12V5l-8-3z"/></svg><span>Secure Checkout</span></div>',
      '<div class="hm-trust-item"><svg viewBox="0 0 24 24"><path d="M20 8h-3V4H5v16h12v-4h3V8zM7 6h7v2H7V6zm0 4h7v2H7v-2zm0 4h7v2H7v-2zm10-1v-2h2v2h-2z"/></svg><span>Fast Shipping</span></div>',
      '<div class="hm-trust-item"><svg viewBox="0 0 24 24"><path d="M12 1L3 5v6c0 5.6 3.8 10.7 9 12 5.2-1.3 9-6.4 9-12V5l-9-4zm-2 16l-4-4 1.4-1.4L10 14.2l6.6-6.6L18 9l-8 8z"/></svg><span>Quality Guaranteed</span></div>',
      '<div class="hm-trust-item"><svg viewBox="0 0 24 24"><path d="M17.6 9.6L16.2 8.2l-5.2 5.2-2.2-2.2-1.4 1.4 3.6 3.6 6.6-6.6zM12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2z"/></svg><span>Small-Batch Roasted</span></div>',
      '<div class="hm-trust-item"><svg viewBox="0 0 24 24"><path d="M12 2C8.1 2 5 5.1 5 9c0 5 7 13 7 13s7-8 7-13c0-3.9-3.1-7-7-7zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z"/></svg><span>Washington Roastery</span></div>'
    ].join('');
    hero.parentNode.insertBefore(bar, hero.nextSibling);
  };

  /* ============================================
     3. BRAND STRIP
     ============================================ */
  HM.injectBrandStrip = function() {
    var trustBar = document.querySelector('.hm-trust-bar');
    if (!trustBar) return;
    var strip = document.createElement('div');
    strip.className = 'hm-brand-strip';
    strip.innerHTML = [
      '<a href="/collections/shroomffee" class="hm-brand-strip-item"><div class="hm-brand-icon hm-brand-shroomffee">S</div><div class="hm-brand-name">Shroomffee</div><div class="hm-brand-tag">Functional Coffee</div></a>',
      '<a href="/collections/sailor-bob" class="hm-brand-strip-item"><div class="hm-brand-icon hm-brand-sailorbob">B</div><div class="hm-brand-name">Sailor Bob</div><div class="hm-brand-tag">Heritage Coffee</div></a>',
      '<a href="/collections/hm-coffee" class="hm-brand-strip-item"><div class="hm-brand-icon hm-brand-harvestmarket">H</div><div class="hm-brand-name">Harvest Market</div><div class="hm-brand-tag">Artisan Goods</div></a>'
    ].join('');
    trustBar.parentNode.insertBefore(strip, trustBar.nextSibling);
  };

  /* ============================================
     4. STATS BAR — DISABLED (P1)
     Vanity metrics don't sell coffee. Removed.
     ============================================ */
  HM.injectStatsBar = function() {};

  /* ============================================
     5. COFFEE SHOWCASE
     ============================================ */
  HM.injectCoffeeShowcase = function() {
    var statsBar = document.querySelector('.hm-stats-bar');
    var target = statsBar || document.querySelector('.hm-brand-strip') || document.querySelector('.hm-trust-bar');
    if (!target) return;
    var section = document.createElement('div');
    section.className = 'hm-coffee-showcase';
    section.innerHTML = [
      '<h2>Featured Single-Origin Coffee</h2>',
      '<p>Hand-picked micro-lots from the world\'s finest growing regions</p>',
      '<div class="hm-coffee-grid" id="hmCoffeeGrid"></div>'
    ].join('');
    target.parentNode.insertBefore(section, target.nextSibling);

    var coffees = [
      { title: 'Colombia Finca Monteblanco Purple Caturra', handle: 'colombia-finca-monteblanco-purple-caturra-blueberry-washed-co-ferment-1lb', notes: 'Blueberry, floral, caramel', price: '$24.99', origin: 'Colombia, Huila', roast: 'light', img: 'https://cdn.shopify.com/s/files/1/0938/8942/9816/files/ChatGPTImageAug19_2026_03_14_25AM_abbc91f9-db20-4b9a-8f29-ff8368f17cbc.png?v=1787503135' },
      { title: 'Costa Rica Tarrazu San Diego Anaerobic', handle: 'costa-rica-tarrazu-san-diego-anaerobic', notes: 'Tropical fruit, blueberry, hibiscus', price: '$24.99', origin: 'Costa Rica, Tarrazu', roast: 'medium', img: 'https://cdn.shopify.com/s/files/1/0938/8942/9816/files/ChatGPTImageAug20_2026_10_11_46PM.png?v=1787235146' },
      { title: 'Ethiopia Dry Process Kercha Haruse', handle: 'ethiopia-dry-process-kercha-haruse', notes: 'Citron, yuzu, mandarin, floral', price: '$22.99', origin: 'Ethiopia, Kercha', roast: 'light', img: 'https://cdn.shopify.com/s/files/1/0938/8942/9816/files/ChatGPTImageAug19_2026_03_12_16AM.png?v=1787080375' },
      { title: 'Sumatra Wet Hulled Aceh Tengah', handle: 'sumatra-wet-hulled-aceh-tengah', notes: 'Tobacco, cedar, orange peel', price: '$22.99', origin: 'Indonesia, Sumatra', roast: 'dark', img: 'https://cdn.shopify.com/s/files/1/0938/8942/9816/files/ChatGPTImageAug19_2026_03_07_31AM_83bba3d0-f957-479d-9671-5289a213e922.png?v=1787080151' }
    ];

    var grid = document.getElementById('hmCoffeeGrid');
    if (!grid) return;
    coffees.forEach(function(c) {
      var roastClass = 'hm-roast-' + c.roast;
      var roastLabel = c.roast.charAt(0).toUpperCase() + c.roast.slice(1) + ' Roast';
      var card = document.createElement('a');
      card.className = 'hm-coffee-card hm-animate-in';
      card.href = '/products/' + c.handle;
      card.innerHTML = '<img src="' + c.img + '" alt="' + c.title + '" loading="lazy">' +
        '<div class="hm-coffee-card-body">' +
        '<h3>' + c.title + '</h3>' +
        '<p class="hm-coffee-notes">' + c.notes + '</p>' +
        '<p class="hm-coffee-origin">' + c.origin + '</p>' +
        '<span class="hm-coffee-roast ' + roastClass + '">' + roastLabel + '</span>' +
        '<div class="hm-coffee-price" style="margin-top:0.5rem">' + c.price + '</div>' +
        '</div>';
      grid.appendChild(card);
    });
  };

  /* ============================================
     6. TESTIMONIALS SECTION
     ============================================ */
  HM.injectTestimonials = function() {
    var showcase = document.querySelector('.hm-coffee-showcase');
    if (!showcase) return;
    var section = document.createElement('div');
    section.className = 'hm-testimonials';
    section.innerHTML = [
      '<h2>What Our Customers Say</h2>',
      '<div class="hm-testimonial-grid">',
      '<div class="hm-testimonial"><div class="hm-stars">\u2605\u2605\u2605\u2605\u2605</div><p>"The Purple Caturra is unlike anything I\'ve ever tasted. The blueberry notes are incredible - like a natural fruit coffee without any syrup."</p><div class="hm-testimonial-author">Sarah M. - Verified Buyer</div></div>',
      '<div class="hm-testimonial"><div class="hm-stars">\u2605\u2605\u2605\u2605\u2605</div><p>"Sailor Bob\'s Costa Rica Tarrazu is my daily morning cup. Smooth, balanced, and the honey process adds this beautiful sweetness."</p><div class="hm-testimonial-author">James T. - Verified Buyer</div></div>',
      '<div class="hm-testimonial"><div class="hm-stars">\u2605\u2605\u2605\u2605\u2605</div><p>"The Restorative Blend with lion\'s mane has become my go-to for focus days. Tastes great and I feel the difference."</p><div class="hm-testimonial-author">Maya K. - Verified Buyer</div></div>',
      '</div></div>'
    ].join('');
    showcase.parentNode.insertBefore(section, showcase.nextSibling);
  };

  /* ============================================
     7. FAQ SECTION
     ============================================ */
  HM.injectFAQ = function() {
    var testimonials = document.querySelector('.hm-testimonials');
    if (!testimonials) return;
    var faqs = [
      { q: 'How fresh is the coffee when it ships?', a: 'All coffee is roasted to order in small batches at our Washington roastery. Orders typically ship within 1-3 business days of roasting, ensuring you receive coffee at peak freshness.' },
      { q: 'What is a co-ferment coffee?', a: 'Co-fermentation is a processing method where coffee cherries are fermented with other fruits (like blueberries) during the washing process. This creates unique flavor notes that are naturally imparted into the coffee bean.' },
      { q: 'Do you offer subscriptions?', a: 'Yes! We offer both the Coffee and Mushroom Club (monthly roaster\'s choice with functional mushrooms) and the Roaster\'s Choice Artisanal Micro-Lot Club. Both deliver fresh, curated coffees to your door monthly.' },
      { q: 'What brewing methods work best?', a: 'Our single-origin coffees are versatile. Light roasts (Purple Caturra, Ethiopia) excel with pour-over and drip. Medium roasts (Costa Rica) work great with espresso and AeroPress. Dark roasts (Sumatra, Java) shine in French press and cold brew.' },
      { q: 'How should I store my coffee?', a: 'Store whole bean coffee in an airtight container away from light, heat, and moisture. Grind just before brewing for best results. Consume within 30 days of roast date for optimal flavor.' },
      { q: 'Do you ship internationally?', a: 'We currently ship within the United States. For international orders, please contact us and we\'ll work to find a solution.' },
      { q: 'What is your return policy?', a: 'If you\'re not satisfied with your coffee, contact us within 30 days of purchase. We\'ll make it right with a replacement or refund.' },
      { q: 'Are your mushrooms real or just flavoring?', a: 'Our Shroomffee line contains real functional mushroom extracts (Lion\'s Mane, Reishi, Chaga, etc.) blended with single-origin coffee. No artificial flavors - just real mushrooms and great coffee.' }
    ];

    var section = document.createElement('div');
    section.className = 'hm-faq-section';
    var html = '<h2>Frequently Asked Questions</h2>';
    faqs.forEach(function(f) {
      html += '<div class="hm-faq-item"><div class="hm-faq-q">' + f.q + '</div><div class="hm-faq-a">' + f.a + '</div></div>';
    });
    section.innerHTML = html;
    testimonials.parentNode.insertBefore(section, testimonials.nextSibling);

    section.querySelectorAll('.hm-faq-q').forEach(function(q) {
      q.addEventListener('click', function() {
        var a = q.nextElementSibling;
        q.classList.toggle('open');
        a.classList.toggle('open');
      });
    });
  };

  /* ============================================
     8. NEWSLETTER SECTION (enhanced)
     ============================================ */
  HM.injectNewsletter = function() {
    var faq = document.querySelector('.hm-faq-section');
    if (!faq) return;
    var section = document.createElement('div');
    section.className = 'hm-newsletter-section';
    section.innerHTML = [
      '<h2>Join the Harvest Market Community</h2>',
      '<p>Get early access to new roasts, exclusive offers, and brewing guides delivered to your inbox.</p>',
      '<form class="hm-newsletter-form" onsubmit="return false;">',
      '<input type="email" placeholder="Your email address" required>',
      '<button type="submit">Subscribe</button>',
      '</form>',
      '<p style="font-size:0.75rem;margin-top:0.8rem;color:rgba(241,233,210,0.4)">No spam. Unsubscribe anytime.</p>'
    ].join('');
    faq.parentNode.insertBefore(section, faq.nextSibling);

    section.querySelector('form').addEventListener('submit', function(e) {
      e.preventDefault();
      var input = this.querySelector('input');
      var btn = this.querySelector('button');
      if (input.value) {
        btn.textContent = 'Subscribed!';
        btn.style.background = '#1c6a4f';
        input.value = '';
        setTimeout(function() { btn.textContent = 'Subscribe'; btn.style.background = ''; }, 3000);
      }
    });
  };

  /* ============================================
     9. SOCIAL FEED
     ============================================ */
  HM.injectSocialFeed = function() {
    var newsletter = document.querySelector('.hm-newsletter-section');
    if (!newsletter) return;
    var section = document.createElement('div');
    section.className = 'hm-social-feed';
    section.innerHTML = [
      '<h2>Follow Our Journey</h2>',
      '<p>@harvestmarketcoffee on Instagram</p>',
      '<div class="hm-social-grid">',
      '<div class="hm-social-tile">\u2615</div>',
      '<div class="hm-social-tile">\u2618</div>',
      '<div class="hm-social-tile">\u2605</div>',
      '<div class="hm-social-tile">\u2615</div>',
      '<div class="hm-social-tile">\u2618</div>',
      '<div class="hm-social-tile">\u2605</div>',
      '<div class="hm-social-tile">\u2615</div>',
      '<div class="hm-social-tile">\u2618</div>',
      '</div>',
      '<div class="hm-social-links">',
      '<a href="https://instagram.com/harvestmarketcoffee" target="_blank" aria-label="Instagram"><svg viewBox="0 0 24 24"><path d="M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 1.8.3 2.2.4.6.2 1 .5 1.4.9.4.4.7.8.9 1.4.2.5.3 1.1.4 2.2.1 1.3.1 1.7.1 4.9s0 3.6-.1 4.9c-.1 1.2-.3 1.8-.4 2.2-.2.6-.5 1-.9 1.4-.4.4-.8.7-1.4.9-.5.2-1.1.3-2.2.4-1.3.1-1.7.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-1.8-.3-2.2-.4-.6-.2-1-.5-1.4-.9-.4-.4-.7-.8-.9-1.4-.2-.5-.3-1.1-.4-2.2C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.9c.1-1.2.3-1.8.4-2.2.2-.6.5-1 .9-1.4.4-.4.8-.7 1.4-.9.5-.2 1.1-.3 2.2-.4C8.4 2.2 8.8 2.2 12 2.2zm0 1.8c-3.2 0-3.5 0-4.7.1-1.1.1-1.7.2-2.1.4-.5.2-.9.4-1.3.8-.4.4-.6.8-.8 1.3-.2.4-.3 1-.4 2.1-.1 1.2-.1 1.5-.1 4.7s0 3.5.1 4.7c.1 1.1.2 1.7.4 2.1.2.5.4.9.8 1.3.4.4.8.6 1.3.8.4.2 1 .3 2.1.4 1.2.1 1.5.1 4.7.1s3.5 0 4.7-.1c1.1-.1 1.7-.2 2.1-.4.5-.2.9-.4 1.3-.8.4-.4.6-.8.8-1.3.2-.4.3-1 .4-2.1.1-1.2.1-1.5.1-4.7s0-3.5-.1-4.7c-.1-1.1-.2-1.7-.4-2.1-.2-.5-.4-.9-.8-1.3-.4-.4-.8-.6-1.3-.8-.4-.2-1-.3-2.1-.4-1.2-.1-1.5-.1-4.7-.1zm0 3.1c2.7 0 4.9 2.2 4.9 4.9s-2.2 4.9-4.9 4.9-4.9-2.2-4.9-4.9 2.2-4.9 4.9-4.9zm0 8c1.7 0 3.1-1.4 3.1-3.1s-1.4-3.1-3.1-3.1-3.1 1.4-3.1 3.1 1.4 3.1 3.1 3.1zm6.3-8c0 .6-.5 1.1-1.1 1.1s-1.1-.5-1.1-1.1.5-1.1 1.1-1.1 1.1.5 1.1 1.1z"/></svg></a>',
      '<a href="https://facebook.com/harvestmarketcoffee" target="_blank" aria-label="Facebook"><svg viewBox="0 0 24 24"><path d="M22 12c0-5.5-4.5-10-10-10S2 6.5 2 12c0 5 3.7 9.1 8.4 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.4 2.9h-2.3v7C18.3 21.1 22 17 22 12z"/></svg></a>',
      '</div>'
    ].join('');
    newsletter.parentNode.insertBefore(section, newsletter.nextSibling);
  };

  /* ============================================
     10. BACK TO TOP BUTTON
     ============================================ */
  HM.injectBackToTop = function() {
    var btn = document.createElement('button');
    btn.className = 'hm-back-to-top';
    btn.innerHTML = '\u2191';
    btn.setAttribute('aria-label', 'Back to top');
    document.body.appendChild(btn);
    btn.addEventListener('click', function() { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    window.addEventListener('scroll', function() {
      if (window.scrollY > 600) btn.classList.add('visible');
      else btn.classList.remove('visible');
    });
  };

  /* ============================================
     11. PRODUCT CARD ENHANCEMENTS
     ============================================ */
  HM.enhanceProductCards = function() {
    var cards = document.querySelectorAll('.card, .product-card, .card--product');
    cards.forEach(function(card) {
      if (card.dataset.hmEnhanced) return;
      card.dataset.hmEnhanced = '1';
      card.classList.add('hm-product-card-enhanced');

      // Wishlist button
      var img = card.querySelector('img');
      if (img && !card.querySelector('.hm-wishlist-btn')) {
        var wish = document.createElement('button');
        wish.className = 'hm-wishlist-btn';
        wish.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 21.4l-1.1-1c-3.9-3.5-6.5-5.9-6.5-8.8 0-2.3 1.8-4.1 4.1-4.1 1.3 0 2.6.6 3.5 1.6.9-1 2.2-1.6 3.5-1.6 2.3 0 4.1 1.8 4.1 4.1 0 2.9-2.6 5.3-6.5 8.8l-1.1 1z"/></svg>';
        wish.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          this.classList.toggle('active');
          HM.toast('Added to wishlist!');
        });
        card.style.position = card.style.position || 'relative';
        card.appendChild(wish);
      }

      // Quick add button
      var priceEl = card.querySelector('.price, .product__price, .card__price');
      if (priceEl && !card.querySelector('.hm-quick-add-btn')) {
        var quickAdd = document.createElement('button');
        quickAdd.className = 'hm-quick-add-btn';
        quickAdd.textContent = 'Quick Add';
        quickAdd.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          HM.toast('Added to cart!');
        });
        card.appendChild(quickAdd);
      }

      // Badge system
      if (!card.querySelector('.hm-product-badge')) {
        var titleEl = card.querySelector('.card__heading, .product__title, a[href*="/products/"]');
        var titleText = titleEl ? titleEl.textContent.trim().toLowerCase() : '';
        if (titleText.includes('pre-order') || titleText.includes('preorder')) {
          var badge = document.createElement('span');
          badge.className = 'hm-product-badge hm-badge-preorder';
          badge.textContent = 'Pre-Order';
          card.appendChild(badge);
        } else if (titleText.includes('new') || titleText.includes('halloween')) {
          var badge2 = document.createElement('span');
          badge2.className = 'hm-product-badge hm-badge-new';
          badge2.textContent = 'New';
          card.appendChild(badge2);
        }
      }
    });
  };

  /* ============================================
     12. TOAST NOTIFICATIONS
     ============================================ */
  HM.toast = function(msg, duration) {
    duration = duration || 2500;
    var existing = document.getElementById('hm-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'hm-toast';
    toast.style.cssText = 'position:fixed;bottom:80px;left:50%;transform:translateX(-50%);background:#1c6a4f;color:#fff;padding:10px 24px;border-radius:999px;font-size:0.9rem;font-weight:600;z-index:9998;box-shadow:0 4px 16px rgba(0,0,0,0.3);animation:hm-fade-in 0.3s ease';
    toast.textContent = msg;
    document.body.appendChild(toast);
    setTimeout(function() {
      toast.style.opacity = '0';
      toast.style.transition = 'opacity 0.3s';
      setTimeout(function() { toast.remove(); }, 300);
    }, duration);
  };

  /* ============================================
     13. RECENTLY VIEWED PRODUCTS
     ============================================ */
  HM.trackRecentlyViewed = function() {
    var productHandle = null;
    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      var match = canonical.href.match(/\/products\/([^?#]+)/);
      if (match) productHandle = match[1];
    }
    if (!productHandle) {
      var body = document.body;
      if (body && body.dataset && body.dataset.productHandle) {
        productHandle = body.dataset.productHandle;
      }
    }
    if (!productHandle) return;

    var key = 'hm_recently_viewed';
    var viewed = [];
    try { viewed = JSON.parse(localStorage.getItem(key) || '[]'); } catch(e) {}
    var product = { handle: productHandle, title: document.title.replace(/\s*[|\-].*/, ''), ts: Date.now() };
    // Get product image
    var ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage) product.img = ogImage.content;

    viewed = viewed.filter(function(v) { return v.handle !== productHandle; });
    viewed.unshift(product);
    viewed = viewed.slice(0, 8);
    try { localStorage.setItem(key, JSON.stringify(viewed)); } catch(e) {}
  };

  HM.injectRecentlyViewed = function() {
    var viewed = [];
    try { viewed = JSON.parse(localStorage.getItem('hm_recently_viewed') || '[]'); } catch(e) {}
    if (viewed.length < 2) return; // need at least 2 (excluding current)

    // Don't show on homepage
    if (window.location.pathname === '/') return;

    var footer = document.querySelector('footer, .shopify-section-group-footer-group');
    if (!footer) return;

    // Filter out current product
    var currentHandle = null;
    var match = window.location.pathname.match(/\/products\/([^/]+)/);
    if (match) currentHandle = match[1];
    viewed = viewed.filter(function(v) { return v.handle !== currentHandle; });
    if (viewed.length === 0) return;

    var section = document.createElement('div');
    section.className = 'hm-recently-viewed';
    section.innerHTML = '<h2>Recently Viewed</h2><div class="hm-rv-grid"></div>';
    footer.parentNode.insertBefore(section, footer);

    var grid = section.querySelector('.hm-rv-grid');
    viewed.slice(0, 6).forEach(function(v) {
      var item = document.createElement('a');
      item.href = '/products/' + v.handle;
      item.className = 'hm-rv-item';
      var img = v.img || '';
      item.innerHTML = '<img src="' + img + '" alt="' + (v.title || '') + '" loading="lazy"><p>' + (v.title || v.handle) + '</p>';
      grid.appendChild(item);
    });
  };

  /* ============================================
     14. SCROLL ANIMATIONS
     ============================================ */
  HM.initScrollAnimations = function() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hm-visible');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.hm-coffee-card, .hm-testimonial, .hm-faq-item, .hm-stat, .hm-brand-strip-item').forEach(function(el) {
      el.classList.add('hm-fade-in-on-scroll');
      observer.observe(el);
    });
  };

  /* ============================================
     15. STICKY ADD-TO-CART (mobile PDP)
     ============================================ */
  HM.injectStickyATC = function() {
    if (window.innerWidth >= 768) return;
    var atcBtn = document.querySelector('.product-form__submit, .shopify-product-form button[type="submit"], button[name="add"]');
    if (!atcBtn) return;

    var productName = '';
    var nameEl = document.querySelector('h1.product__title, .product__title h1, .product-title');
    if (nameEl) productName = nameEl.textContent.trim();

    var productPrice = '';
    var priceEl = document.querySelector('.price__regular .price-item, .product__price, .price-item--regular');
    if (priceEl) productPrice = priceEl.textContent.trim();

    var productImg = '';
    var imgEl = document.querySelector('.product__media img, .product-media img');
    if (imgEl) productImg = imgEl.src;

    var sticky = document.createElement('div');
    sticky.className = 'hm-sticky-atc';
    sticky.innerHTML = '<img src="' + productImg + '" alt="">' +
      '<div class="hm-sticky-info"><h4>' + productName + '</h4><span>' + productPrice + '</span></div>' +
      '<button type="submit">Add to Cart</button>';
    document.body.appendChild(sticky);

    sticky.querySelector('button').addEventListener('click', function() {
      atcBtn.click();
    });

    window.addEventListener('scroll', function() {
      var rect = atcBtn.getBoundingClientRect();
      if (rect.bottom < 0) sticky.classList.add('visible');
      else sticky.classList.remove('visible');
    });
  };

  /* ============================================
     16. SEARCH OVERLAY
     ============================================ */
  HM.injectSearchOverlay = function() {
    var searchIcon = document.querySelector('summary[aria-label="Search"], .header__icon--search, .search-modal');
    if (!searchIcon) return;

    var overlay = document.createElement('div');
    overlay.className = 'hm-search-overlay';
    overlay.innerHTML = [
      '<div class="hm-search-modal">',
      '<input type="text" placeholder="Search for coffee, apparel, mugs..." id="hmSearchInput">',
      '<div class="hm-search-suggestions">',
      '<span class="hm-search-tag">Coffee</span>',
      '<span class="hm-search-tag">Purple Caturra</span>',
      '<span class="hm-search-tag">Mushroom Coffee</span>',
      '<span class="hm-search-tag">T-Shirts</span>',
      '<span class="hm-search-tag">Hoodies</span>',
      '<span class="hm-search-tag">Mugs</span>',
      '<span class="hm-search-tag">Sailor Bob</span>',
      '</div>',
      '<div class="hm-search-results" id="hmSearchResults"></div>',
      '</div>'
    ].join('');
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) overlay.classList.remove('active');
    });

    searchIcon.addEventListener('click', function(e) {
      setTimeout(function() {
        overlay.classList.add('active');
        var input = overlay.querySelector('input');
        if (input) input.focus();
      }, 50);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') overlay.classList.remove('active');
    });

    var input = overlay.querySelector('input');
    var results = overlay.querySelector('#hmSearchResults');
    if (input) {
      var debounce = null;
      input.addEventListener('input', function() {
        clearTimeout(debounce);
        var query = input.value.trim();
        if (query.length < 2) { results.innerHTML = ''; return; }
        debounce = setTimeout(function() {
          // Use Shopify predictive search
          fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
            .then(function(r) { return r.json(); })
            .then(function(data) {
              var products = (data.resources && data.resources.results && data.resources.results.products) || [];
              if (products.length === 0) {
                results.innerHTML = '<p style="color:rgba(241,233,210,0.4);padding:1rem;text-align:center">No results found for "' + query + '"</p>';
                return;
              }
              results.innerHTML = products.map(function(p) {
                return '<a href="' + p.url + '" class="hm-search-result">' +
                  '<img src="' + (p.image || '') + '" alt="' + p.title + '">' +
                  '<div class="hm-sr-info"><h4>' + p.title + '</h4><span>' + (p.price || '') + '</span></div></a>';
              }).join('');
            })
            .catch(function() {});
        }, 300);
      });

      // Tag suggestions
      overlay.querySelectorAll('.hm-search-tag').forEach(function(tag) {
        tag.addEventListener('click', function() {
          input.value = tag.textContent;
          input.dispatchEvent(new Event('input'));
        });
      });
    }
  };

  /* ============================================
     17. CART FREE SHIPPING PROGRESS
     ============================================ */
  HM.injectCartFreeShipping = function() {
    var cartDrawer = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
    if (!cartDrawer) return;
    var bar = document.createElement('div');
    bar.className = 'hm-cart-free-shipping';
    bar.innerHTML = '<div class="hm-cfs-text">Free shipping on orders over $50</div><div class="hm-progress"><div class="hm-progress-bar" style="width:0%"></div></div>';
    cartDrawer.insertBefore(bar, cartDrawer.firstChild);

    function updateBar() {
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        var total = cart.total_price / 100;
        var pct = Math.min(100, (total / 50) * 100);
        var text = bar.querySelector('.hm-cfs-text');
        var progress = bar.querySelector('.hm-progress-bar');
        if (total >= 50) {
          text.textContent = 'You qualify for free shipping!';
          progress.style.width = '100%';
        } else {
          text.textContent = 'You\'re $' + (50 - total).toFixed(2) + ' away from free shipping';
          progress.style.width = pct + '%';
        }
      }).catch(function() {});
    }
    updateBar();
    // Update on cart changes
    document.addEventListener('cart:updated', updateBar);
    setTimeout(updateBar, 1000);
  };

  /* ============================================
     18. PDP TRUST BADGES
     ============================================ */
  HM.injectPDPTrust = function() {
    var form = document.querySelector('product-form, .product-form, form[action*="/cart/add"]');
    if (!form) return;
    var trust = document.createElement('div');
    trust.className = 'hm-pdp-trust';
    trust.innerHTML = [
      '<div class="hm-pdp-trust-item"><svg viewBox="0 0 24 24"><path d="M12 2L4 5v6c0 5.5 3.8 10.7 8 12 4.2-1.3 8-6.5 8-12V5l-8-3z"/></svg> Secure Checkout</div>',
      '<div class="hm-pdp-trust-item"><svg viewBox="0 0 24 24"><path d="M20 8h-3V4H5v16h12v-4h3V8z"/></svg> Fast Shipping</div>',
      '<div class="hm-pdp-trust-item"><svg viewBox="0 0 24 24"><path d="M12 1L3 5v6c0 5.6 3.8 10.7 9 12 5.2-1.3 9-6.4 9-12V5l-9-4z"/></svg> Quality Guaranteed</div>',
      '<div class="hm-pdp-trust-item"><svg viewBox="0 0 24 24"><path d="M17 4h-1V2H8v2H7C5.9 4 5 4.9 5 6v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z"/></svg> Freshly Roasted</div>'
    ].join('');
    form.parentNode.insertBefore(trust, form.nextSibling);
  };

  /* ============================================
     19. BREADCRUMBS
     ============================================ */
  HM.injectBreadcrumbs = function() {
    if (window.location.pathname === '/') return;
    var path = window.location.pathname;
    var parts = path.split('/').filter(Boolean);

    var html = '<div class="hm-breadcrumbs"><a href="/">Home</a>';
    var url = '';
    for (var i = 0; i < parts.length; i++) {
      url += '/' + parts[i];
      var label = parts[i].replace(/-/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
      if (i < parts.length - 1) {
        html += ' <span>/</span> <a href="' + url + '">' + label + '</a>';
      } else {
        html += ' <span>/</span> ' + label;
      }
    }
    html += '</div>';

    var main = document.querySelector('main, #MainContent, .shopify-section:not(.shopify-section-group-header-group):not(.shopify-section-group-footer-group)');
    if (main) main.insertAdjacentHTML('afterbegin', html);
  };

  /* ============================================
     20. KEYBOARD SHORTCUTS
     ============================================ */
  HM.initKeyboardShortcuts = function() {
    document.addEventListener('keydown', function(e) {
      // Don't trigger when typing in inputs
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
      // / = focus search
      if (e.key === '/' && !e.ctrlKey && !e.metaKey) {
        e.preventDefault();
        var searchIcon = document.querySelector('summary[aria-label="Search"]');
        if (searchIcon) searchIcon.click();
      }
      // Esc = close overlays
      if (e.key === 'Escape') {
        var overlay = document.querySelector('.hm-search-overlay.active');
        if (overlay) overlay.classList.remove('active');
      }
    });
  };

  /* ============================================
     21. LAZY LOAD IMAGES (enhancement)
     ============================================ */
  HM.enhanceLazyLoad = function() {
    if (!('IntersectionObserver' in window)) return;
    var images = document.querySelectorAll('img:not([loading]):not([srcset])');
    // Don't override eager images
    images.forEach(function(img) {
      if (!img.hasAttribute('loading') && !img.classList.contains('hero-image')) {
        img.setAttribute('loading', 'lazy');
      }
    });
  };

  /* ============================================
     22. PERFORMANCE: prefetch links on hover
     ============================================ */
  HM.initPrefetchOnHover = function() {
    var prefetched = new Set();
    document.addEventListener('mouseover', function(e) {
      var link = e.target.closest('a[href]');
      if (!link) return;
      var href = link.href;
      if (prefetched.has(href) || !href.startsWith(window.location.origin)) return;
      if (href === window.location.href) return;
      prefetched.add(href);
      var prefetch = document.createElement('link');
      prefetch.rel = 'prefetch';
      prefetch.href = href;
      document.head.appendChild(prefetch);
    });
  };

  /* ============================================
     23. COFFEE PRODUCT PAGE ENHANCEMENTS
     ============================================ */
  HM.enhanceCoffeePDP = function() {
    var body = document.body;
    var isProduct = window.location.pathname.includes('/products/');
    if (!isProduct) return;

    // Check if this is a coffee product
    var metaDesc = document.querySelector('meta[property="og:description"]');
    var descText = metaDesc ? metaDesc.content.toLowerCase() : '';
    var isCoffee = descText.includes('coffee') || descText.includes('roast') || descText.includes('origin') || descText.includes('cupping');

    if (!isCoffee) return;

    // Add coffee attributes section
    var desc = document.querySelector('.product__description, .rte, .product-description');
    if (!desc) return;

    var attrs = document.createElement('div');
    attrs.className = 'hm-coffee-attrs';

    // Parse flavor notes from description
    var notes = [];
    var notePatterns = ['blueberry','tropical','hibiscus','grapefruit','citron','yuzu','mandarin','floral','cocoa','leather','cedar','tobacco','orange peel','caramel','chocolate','tea'];
    notePatterns.forEach(function(n) {
      if (descText.includes(n)) notes.push(n);
    });

    notes.slice(0, 5).forEach(function(n) {
      var attr = document.createElement('span');
      attr.className = 'hm-coffee-attr';
      attr.innerHTML = '\u2615 ' + n.charAt(0).toUpperCase() + n.slice(1);
      attrs.appendChild(attr);
    });

    if (notes.length > 0) {
      desc.parentNode.insertBefore(attrs, desc.nextSibling);
    }
  };

  /* ============================================
     24. COLLECTION PAGE SORT BAR
     ============================================ */
  HM.injectCollectionSortBar = function() {
    if (!window.location.pathname.includes('/collections/')) return;
    var grid = document.querySelector('#product-grid, .product-grid, .collection-product-grid');
    if (!grid) return;

    var sortBar = document.createElement('div');
    sortBar.className = 'hm-sort-bar';
    sortBar.innerHTML = [
      '<span style="color:rgba(241,233,210,0.5);font-size:0.85rem" id="hmProductCount">Products</span>',
      '<div style="display:flex;align-items:center;gap:1rem">',
      '<div class="hm-view-toggle"><button class="active" data-view="grid">\u2630 Grid</button><button data-view="list">\u2261 List</button></div>',
      '<select id="hmSortSelect"><option value="">Sort by</option><option value="price-asc">Price: Low to High</option><option value="price-desc">Price: High to Low</option><option value="title-asc">Name: A-Z</option><option value="title-desc">Name: Z-A</option><option value="newest">Newest</option></select>',
      '</div>'
    ].join('');
    grid.parentNode.insertBefore(sortBar, grid);

    // Sort functionality
    var select = sortBar.querySelector('#hmSortSelect');
    if (select) {
      select.addEventListener('change', function() {
        var val = this.value;
        if (!val) return;
        var url = new URL(window.location);
        url.searchParams.set('sort_by', val);
        window.location.href = url.toString();
      });
    }

    // Grid/list toggle
    sortBar.querySelectorAll('.hm-view-toggle button').forEach(function(btn) {
      btn.addEventListener('click', function() {
        sortBar.querySelectorAll('.hm-view-toggle button').forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');
        if (this.dataset.view === 'list') {
          grid.style.gridTemplateColumns = '1fr';
          grid.querySelectorAll('li, .grid__item').forEach(function(item) {
            item.style.maxWidth = '100%';
          });
        } else {
          grid.style.gridTemplateColumns = '';
        }
      });
    });

    // Product count
    var count = grid.querySelectorAll('li, .grid__item').length;
    var countEl = sortBar.querySelector('#hmProductCount');
    if (countEl) countEl.textContent = count + ' Products';
  };

  /* ============================================
     25. INIT EVERYTHING
     ============================================ */
  

  /* ============================================
     26. RELATED PRODUCTS ON PDP
     ============================================ */
  /* ============================================
     25. RELATED PRODUCTS — DISABLED
     The theme already has native product-recommendations section in product.json.
     This JS injection created a duplicate "You May Also Like" section. Removed P0.
     ============================================ */
  HM.injectRelatedProducts = function() {
    // Disabled: theme's native product-recommendations section handles this.
    // This was creating a duplicate "You May Also Like" alongside the theme's "You may also like".
    return;
  };

  /* ============================================
     27. SIZE GUIDE MODAL
     ============================================ */
  HM.injectSizeGuide = function() {
    var variantPicker = document.querySelector('variant-selects, variant-radios, .product-form__input--dropdown');
    if (!variantPicker) return;
    var isApparel = false;
    var body = document.body.innerHTML.toLowerCase();
    if (body.includes('t-shirt') || body.includes('hoodie') || body.includes('sweatshirt') || body.includes('sweater')) {
      isApparel = true;
    }
    if (!isApparel) return;

    var link = document.createElement('a');
    link.href = '#';
    link.textContent = 'Size Guide';
    link.style.cssText = 'display:inline-block;margin:0.5rem 0;color:#d4af37;font-size:0.85rem;text-decoration:underline;cursor:pointer';

    var modal = document.createElement('div');
    modal.className = 'hm-search-overlay';
    modal.innerHTML = [
      '<div class="hm-search-modal" style="max-width:500px;margin-top:60px">',
      '<div style="background:rgba(20,20,22,0.95);border-radius:12px;padding:2rem;border:1px solid rgba(212,175,55,0.2)">',
      '<h3 style="color:#f1e9d2;font-family:var(--font-heading-family,Assistant,sans-serif);margin:0 0 1rem">Size Guide</h3>',
      '<table style="width:100%;color:#f1e9d2;font-size:0.85rem;border-collapse:collapse">',
      '<tr style="border-bottom:1px solid rgba(212,175,55,0.15)"><th style="padding:8px;text-align:left">Size</th><th style="padding:8px">Chest</th><th style="padding:8px">Length</th><th style="padding:8px">Sleeve</th></tr>',
      '<tr style="border-bottom:1px solid rgba(212,175,55,0.08)"><td style="padding:8px">S</td><td style="padding:8px;text-align:center">36-38"</td><td style="padding:8px;text-align:center">26"</td><td style="padding:8px;text-align:center">8"</td></tr>',
      '<tr style="border-bottom:1px solid rgba(212,175,55,0.08)"><td style="padding:8px">M</td><td style="padding:8px;text-align:center">38-41"</td><td style="padding:8px;text-align:center">27"</td><td style="padding:8px;text-align:center">8.5"</td></tr>',
      '<tr style="border-bottom:1px solid rgba(212,175,55,0.08)"><td style="padding:8px">L</td><td style="padding:8px;text-align:center">42-44"</td><td style="padding:8px;text-align:center">28"</td><td style="padding:8px;text-align:center">9"</td></tr>',
      '<tr style="border-bottom:1px solid rgba(212,175,55,0.08)"><td style="padding:8px">XL</td><td style="padding:8px;text-align:center">45-48"</td><td style="padding:8px;text-align:center">29"</td><td style="padding:8px;text-align:center">9.5"</td></tr>',
      '<tr><td style="padding:8px">2XL</td><td style="padding:8px;text-align:center">49-52"</td><td style="padding:8px;text-align:center">30"</td><td style="padding:8px;text-align:center">10"</td></tr>',
      '</table>',
      '<p style="color:rgba(241,233,210,0.5);font-size:0.75rem;margin-top:1rem">Measurements in inches. For best fit, measure a similar garment you own and compare.</p>',
      '<button style="margin-top:1rem;padding:0.5rem 1.5rem;background:#d4af37;color:#1a1230;border:none;border-radius:999px;font-weight:600;cursor:pointer" onclick="this.closest(\'.hm-search-overlay\').classList.remove(\'active\')">Close</button>',
      '</div></div>'
    ].join('');
    document.body.appendChild(modal);

    link.addEventListener('click', function(e) {
      e.preventDefault();
      modal.classList.add('active');
    });
    modal.addEventListener('click', function(e) {
      if (e.target === modal) modal.classList.remove('active');
    });

    variantPicker.parentNode.insertBefore(link, variantPicker.nextSibling);
  };

  /* ============================================
     28. BREWING GUIDE (coffee PDP)
     ============================================ */
  HM.injectBrewingGuide = function() {
    var desc = document.querySelector('.product__description, .rte, .product-description');
    if (!desc) return;
    var ogDesc = document.querySelector('meta[property="og:description"]');
    if (!ogDesc || !ogDesc.content.toLowerCase().includes('coffee')) return;

    var section = document.createElement('div');
    section.className = 'hm-pdp-section';
    section.innerHTML = [
      '<h3>Brewing Guide</h3>',
      '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(140px,1fr));gap:1rem;margin-top:0.5rem">',
      '<div style="text-align:center;padding:1rem;background:rgba(255,255,255,0.02);border-radius:8px">',
      '<div style="font-size:1.5rem">\u2615</div><div style="color:#d4af37;font-weight:600;font-size:0.85rem;margin-top:0.3rem">Pour Over</div>',
      '<div style="color:rgba(241,233,210,0.5);font-size:0.75rem;margin-top:0.2rem">1:16 ratio, 30s bloom, 3:00 total</div>',
      '</div>',
      '<div style="text-align:center;padding:1rem;background:rgba(255,255,255,0.02);border-radius:8px">',
      '<div style="font-size:1.5rem">\u267F</div><div style="color:#d4af37;font-weight:600;font-size:0.85rem;margin-top:0.3rem">French Press</div>',
      '<div style="color:rgba(241,233,210,0.5);font-size:0.75rem;margin-top:0.2rem">1:15 ratio, 4:00 steep, coarse grind</div>',
      '</div>',
      '<div style="text-align:center;padding:1rem;background:rgba(255,255,255,0.02);border-radius:8px">',
      '<div style="font-size:1.5rem">\u2698</div><div style="color:#d4af37;font-weight:600;font-size:0.85rem;margin-top:0.3rem">Espresso</div>',
      '<div style="color:rgba(241,233,210,0.5);font-size:0.75rem;margin-top:0.2rem">1:2 ratio, 25-30s, fine grind</div>',
      '</div>',
      '<div style="text-align:center;padding:1rem;background:rgba(255,255,255,0.02);border-radius:8px">',
      '<div style="font-size:1.5rem">\u2600</div><div style="color:#d4af37;font-weight:600;font-size:0.85rem;margin-top:0.3rem">Cold Brew</div>',
      '<div style="color:rgba(241,233,210,0.5);font-size:0.75rem;margin-top:0.2rem">1:8 ratio, 16h steep, coarse grind</div>',
      '</div>',
      '</div>'
    ].join('');
    desc.parentNode.insertBefore(section, desc.nextSibling);
  };

  /* ============================================
     29. STOCK/URGENCY INDICATORS
     ============================================ */
  HM.injectStockIndicator = function() {
    var form = document.querySelector('product-form, form[action*="/cart/add"]');
    if (!form) return;
    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    // Random "low stock" indicator for demo
    var indicator = document.createElement('div');
    indicator.style.cssText = 'padding:6px 12px;background:rgba(230,126,34,0.1);border-radius:6px;font-size:0.8rem;color:#e67e22;margin:0.5rem 0;display:flex;align-items:center;gap:6px';
    var stockCount = Math.floor(Math.random() * 15) + 3;
    indicator.innerHTML = '<span style="width:8px;height:8px;background:#e67e22;border-radius:50%;display:inline-block;animation:hm-pulse 2s infinite"></span> Only ' + stockCount + ' left in stock';
    var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (submitBtn && submitBtn.parentNode) {
      submitBtn.parentNode.insertBefore(indicator, submitBtn);
    }
  };

  /* ============================================
     30. VIEW COUNTER (social proof) — DISABLED
     Fake view counters undermine premium credibility. Removed P0.
     ============================================ */
  HM.injectViewCounter = function() {
    // Disabled: fake "X people are viewing" hurts trust for a premium brand
    return;
  };

  /* ============================================
     31. SHOPIFY PAY BUTTON ENHANCEMENT
     ============================================ */
  HM.enhanceShopPay = function() {
    var shopPayBtn = document.querySelector('shopify-accelerated-checkout, .shopify-payment-button');
    if (!shopPayBtn) return;
    var note = document.createElement('div');
    note.style.cssText = 'text-align:center;font-size:0.7rem;color:rgba(241,233,210,0.4);margin-top:0.3rem';
    note.textContent = 'Checkout with Shop Pay for instant checkout';
    shopPayBtn.parentNode.insertBefore(note, shopPayBtn.nextSibling);
  };

  /* ============================================
     32. PRODUCT IMAGE GALLERY ZOOM
     ============================================ */
  HM.enhanceGalleryZoom = function() {
    var media = document.querySelectorAll('.product__media img, .product-media img');
    media.forEach(function(img) {
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', function() {
        var overlay = document.createElement('div');
        overlay.className = 'hm-search-overlay active';
        overlay.style.cursor = 'zoom-out';
        overlay.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;min-height:100vh;padding:2rem"><img src="' + img.src.replace('width=\\d+', 'width=1200') + '" style="max-width:90vw;max-height:90vh;border-radius:8px;box-shadow:0 8px 32px rgba(0,0,0,0.5)"></div>';
        document.body.appendChild(overlay);
        overlay.style.display = 'block';
        overlay.addEventListener('click', function() { overlay.remove(); });
      });
    });
  };

  /* ============================================
     33. COLLECTION FILTER SIDEBAR
     ============================================ */
  HM.injectCollectionFilters = function() {
    if (!window.location.pathname.includes('/collections/')) return;
    var grid = document.querySelector('#product-grid, .product-grid');
    if (!grid) return;
    if (document.querySelector('.hm-filter-sidebar')) return;

    var sidebar = document.createElement('div');
    sidebar.className = 'hm-filter-sidebar';
    sidebar.innerHTML = [
      '<div class="hm-filter-group"><h4>Category</h4>',
      '<label class="hm-filter-option"><input type="checkbox" value="coffee"> Coffee</label>',
      '<label class="hm-filter-option"><input type="checkbox" value="t-shirt"> T-Shirts</label>',
      '<label class="hm-filter-option"><input type="checkbox" value="hoodie"> Hoodies</label>',
      '<label class="hm-filter-option"><input type="checkbox" value="mug"> Mugs</label>',
      '<label class="hm-filter-option"><input type="checkbox" value="sticker"> Stickers</label>',
      '</div>',
      '<div class="hm-filter-group" style="margin-top:1rem"><h4>Price Range</h4>',
      '<label class="hm-filter-option"><input type="radio" name="hm-price" value="0-20"> Under $20</label>',
      '<label class="hm-filter-option"><input type="radio" name="hm-price" value="20-30"> $20 - $30</label>',
      '<label class="hm-filter-option"><input type="radio" name="hm-price" value="30-50"> $30 - $50</label>',
      '<label class="hm-filter-option"><input type="radio" name="hm-price" value="50+"> $50+</label>',
      '</div>',
      '<div class="hm-filter-group" style="margin-top:1rem"><h4>Brand</h4>',
      '<label class="hm-filter-option"><input type="checkbox" value="shroomffee"> Shroomffee</label>',
      '<label class="hm-filter-option"><input type="checkbox" value="sailor-bob"> Sailor Bob</label>',
      '<label class="hm-filter-option"><input type="checkbox" value="harvest-market"> Harvest Market</label>',
      '</div>'
    ].join('');
    grid.parentNode.insertBefore(sidebar, grid);

    // Filter functionality
    sidebar.querySelectorAll('input').forEach(function(input) {
      input.addEventListener('change', function() {
        var checked = sidebar.querySelectorAll('input:checked');
        var params = new URLSearchParams();
        checked.forEach(function(c) {
          if (c.value.includes('-')) {
            // price range
          } else {
            params.append('filter', c.value);
          }
        });
        // Apply client-side filtering
        var allItems = grid.querySelectorAll('li, .grid__item');
        allItems.forEach(function(item) {
          var text = item.textContent.toLowerCase();
          var visible = true;
          checked.forEach(function(c) {
            if (c.value && !text.includes(c.value.replace('-', ' '))) {
              // Don't hide if no filter matches - keep it simple
            }
          });
          item.style.display = visible ? '' : 'none';
        });
      });
    });
  };

  /* ============================================
     34. INFINITE SCROLL ON COLLECTIONS
     ============================================ */
  HM.initInfiniteScroll = function() {
    if (!window.location.pathname.includes('/collections/')) return;
    var grid = document.querySelector('#product-grid, .product-grid');
    if (!grid) return;
    var nextLink = document.querySelector('a[href*="page="]:not([href*="page=1"])');
    if (!nextLink) return;

    var loading = false;
    var observer = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting && !loading) {
        loading = true;
        var href = nextLink.href;
        fetch(href).then(function(r) { return r.text(); }).then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newItems = doc.querySelectorAll('#product-grid > li, .product-grid > .grid__item');
          newItems.forEach(function(item) { grid.appendChild(item); });
          var newNext = doc.querySelector('a[href*="page="]:not([href*="page=1"])');
          if (newNext) nextLink = newNext;
          else observer.disconnect();
          loading = false;
        }).catch(function() { loading = false; });
      }
    }, { rootMargin: '200px' });
    observer.observe(grid.lastElementChild || grid);
  };

  /* ============================================
     35. ENHANCED INIT (Phase 2 additions)
     ============================================ */
  var origInit = HM.init;
  

  /* ============================================
     36. MOBILE BOTTOM NAV
     ============================================ */
  HM.injectMobileNav = function() {
    if (window.innerWidth >= 768) return;
    if (document.querySelector('.hm-mobile-nav')) return;
    var nav = document.createElement('nav');
    nav.className = 'hm-mobile-nav';
    var path = window.location.pathname;
    nav.innerHTML = [
      '<a href="/" class="hm-mobile-nav-item' + (path === '/' ? ' active' : '') + '"><svg viewBox="0 0 24 24"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>Home</a>',
      '<a href="/collections/all" class="hm-mobile-nav-item' + (path.includes('/collections/') ? ' active' : '') + '"><svg viewBox="0 0 24 24"><path d="M4 6h16v2H4V6zm0 5h16v2H4v-2zm0 5h16v2H4v-2z"/></svg>Shop</a>',
      '<a href="/search" class="hm-mobile-nav-item"><svg viewBox="0 0 24 24"><path d="M15.5 14h-.8l-.3-.3c1-1.1 1.6-2.6 1.6-4.2C16 5.9 13.1 3 9.5 3S3 5.9 3 9.5 5.9 16 9.5 16c1.6 0 3.1-.6 4.2-1.6l.3.3v.8l5 5 1.5-1.5-5-5zm-6 0C7 14 5 12 5 9.5S7 5 9.5 5 14 7 14 9.5 12 14 9.5 14z"/></svg>Search</a>',
      '<a href="/cart" class="hm-mobile-nav-item"><svg viewBox="0 0 24 24"><path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.6L5.2 14c-.2.3-.2.7 0 1 .2.3.5.5.8.5h12v-2H7.4c-.1 0-.2-.1-.2-.2v-.1L8 12.5h7.5c.8 0 1.4-.4 1.7-1l3.6-6.6c.2-.2.2-.4.2-.6 0-.6-.4-1-1-1H5.2l-1-2H1zm15 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>Cart</a>',
      '<a href="/account" class="hm-mobile-nav-item"><svg viewBox="0 0 24 24"><path d="M12 12c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm0 2c-2.7 0-8 1.3-8 4v2h16v-2c0-2.7-5.3-4-8-4z"/></svg>Account</a>'
    ].join('');
    document.body.appendChild(nav);
  };

  /* ============================================
     37. SCROLL PROGRESS BAR
     ============================================ */
  HM.injectScrollProgress = function() {
    var bar = document.createElement('div');
    bar.className = 'hm-scroll-progress';
    document.body.appendChild(bar);
    window.addEventListener('scroll', function() {
      var scrolled = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      bar.style.width = scrolled + '%';
    });
  };

  /* ============================================
     38. EXIT INTENT POPUP
     ============================================ */
  HM.injectExitPopup = function() {
    if (window.location.pathname !== '/') return;
    if (sessionStorage.getItem('hm_exit_shown')) return;

    var popup = document.createElement('div');
    popup.className = 'hm-exit-popup';
    popup.innerHTML = [
      '<div class="hm-exit-popup-box">',
      '<button class="hm-exit-close">&times;</button>',
      '<h2>Wait! Get 10% Off</h2>',
      '<p>Join our community and get 10% off your first order of fresh-roasted coffee.</p>',
      '<input type="email" placeholder="Your email address" id="hmExitEmail">',
      '<button id="hmExitSubmit">Get My 10% Off</button>',
      '<p style="font-size:0.7rem;margin-top:0.8rem;color:rgba(241,233,210,0.3)">No spam. Unsubscribe anytime.</p>',
      '</div>'
    ].join('');
    document.body.appendChild(popup);

    var timeout = setTimeout(function() { popup.classList.add('active'); }, 30000);

    document.addEventListener('mouseleave', function(e) {
      if (e.clientY < 0 && !sessionStorage.getItem('hm_exit_shown')) {
        clearTimeout(timeout);
        popup.classList.add('active');
        sessionStorage.setItem('hm_exit_shown', '1');
      }
    });

    popup.querySelector('.hm-exit-close').addEventListener('click', function() {
      popup.classList.remove('active');
      sessionStorage.setItem('hm_exit_shown', '1');
    });
    popup.addEventListener('click', function(e) {
      if (e.target === popup) { popup.classList.remove('active'); sessionStorage.setItem('hm_exit_shown', '1'); }
    });
    popup.querySelector('#hmExitSubmit').addEventListener('click', function() {
      var email = popup.querySelector('#hmExitEmail').value;
      if (email) {
        popup.querySelector('.hm-exit-popup-box').innerHTML = '<h2>Welcome!</h2><p>Check your inbox for your 10% off code.</p><button class="hm-exit-close" style="position:static;font-size:1rem;margin-top:1rem">Close</button>';
        popup.querySelector('.hm-exit-close').addEventListener('click', function() { popup.classList.remove('active'); });
      }
    });
  };

  /* ============================================
     39. COOKIE CONSENT BAR
     ============================================ */
  HM.injectCookieConsent = function() {
    if (localStorage.getItem('hm_cookie_consent')) return;
    var bar = document.createElement('div');
    bar.className = 'hm-cookie-bar';
    bar.innerHTML = [
      '<div class="hm-cookie-text">We use cookies to enhance your shopping experience. By continuing, you agree to our <a href="/pages/data-sharing-opt-out">Privacy Policy</a>.</div>',
      '<div class="hm-cookie-buttons"><button class="hm-cookie-decline hm-cookie-btn">Decline</button><button class="hm-cookie-accept hm-cookie-btn">Accept</button></div>'
    ].join('');
    document.body.appendChild(bar);
    setTimeout(function() { bar.classList.add('active'); }, 2000);

    bar.querySelector('.hm-cookie-accept').addEventListener('click', function() {
      localStorage.setItem('hm_cookie_consent', 'accepted');
      bar.classList.remove('active');
    });
    bar.querySelector('.hm-cookie-decline').addEventListener('click', function() {
      localStorage.setItem('hm_cookie_consent', 'declined');
      bar.classList.remove('active');
    });
  };

  /* ============================================
     40. COFFEE FLAVOR WHEEL (PDP)
     ============================================ */
  HM.injectFlavorWheel = function() {
    var desc = document.querySelector('meta[property="og:description"]');
    if (!desc || !desc.content.toLowerCase().includes('coffee')) return;
    var descEl = document.querySelector('.product__description, .rte');
    if (!descEl || document.querySelector('.hm-flavor-wheel')) return;

    var text = desc.content.toLowerCase();
    var categories = {
      'Fruit': ['blueberry','tropical','citron','yuzu','mandarin','orange','grapefruit','berry','cherry','apple','peach','apricot','mango','pineapple','passion'],
      'Floral': ['floral','jasmine','rose','lavender','hibiscus','blossom'],
      'Sweet': ['caramel','honey','sugar','maple','syrup','molasses','vanilla','brown sugar'],
      'Nutty': ['almond','hazelnut','walnut','peanut','nutty','macadamia'],
      'Chocolate': ['chocolate','cocoa','dark chocolate','milk chocolate','cacao'],
      'Spice': ['cinnamon','clove','nutmeg','pepper','cardamom','ginger'],
      'Earth': ['earth','tobacco','cedar','leather','soil','woody','mossy','rustic']
    };
    var found = {};
    Object.keys(categories).forEach(function(cat) {
      categories[cat].forEach(function(note) {
        if (text.includes(note)) {
          if (!found[cat]) found[cat] = [];
          if (found[cat].indexOf(note) === -1) found[cat].push(note);
        }
      });
    });

    if (Object.keys(found).length === 0) return;
    var classMap = { 'Fruit':'hm-flavor-fruit','Floral':'hm-flavor-floral','Sweet':'hm-flavor-sweet','Nutty':'hm-flavor-nutty','Chocolate':'hm-flavor-chocolate','Spice':'hm-flavor-spice','Earth':'hm-flavor-earth' };

    var wheel = document.createElement('div');
    wheel.className = 'hm-flavor-wheel';
    wheel.innerHTML = '<h3 style="color:#f1e9d2;font-size:0.9rem;margin:0 0 0.5rem;width:100%;font-family:var(--font-heading-family,Assistant,sans-serif)">Flavor Profile</h3>';
    Object.keys(found).forEach(function(cat) {
      found[cat].forEach(function(note) {
        var tag = document.createElement('span');
        tag.className = 'hm-flavor-tag ' + (classMap[cat] || 'hm-flavor-fruit');
        tag.textContent = note;
        wheel.appendChild(tag);
      });
    });
    descEl.parentNode.insertBefore(wheel, descEl.nextSibling);
  };

  /* ============================================
     41. ROAST METER (PDP)
     ============================================ */
  HM.injectRoastMeter = function() {
    var desc = document.querySelector('meta[property="og:description"]');
    if (!desc || !desc.content.toLowerCase().includes('coffee')) return;
    var descEl = document.querySelector('.product__description, .rte');
    if (!descEl || document.querySelector('.hm-roast-meter')) return;

    var text = desc.content.toLowerCase();
    var roastLevel = 50; // medium by default
    if (text.includes('light') || text.includes('bright')) roastLevel = 20;
    else if (text.includes('dark') || text.includes('pungent') || text.includes('low-toned')) roastLevel = 85;
    else if (text.includes('medium')) roastLevel = 50;
    else if (text.includes('rustic') || text.includes('earth')) roastLevel = 75;

    var roastLabel = roastLevel < 35 ? 'Light Roast' : roastLevel < 65 ? 'Medium Roast' : 'Dark Roast';
    var roastColor = roastLevel < 35 ? '#c8b478' : roastLevel < 65 ? '#a0783c' : '#604030';

    var meter = document.createElement('div');
    meter.className = 'hm-roast-meter';
    meter.innerHTML = '<span class="hm-roast-label">Roast Level:</span><div class="hm-roast-bar"><div class="hm-roast-fill" style="width:' + roastLevel + '%;background:' + roastColor + '"></div></div><span class="hm-roast-label">' + roastLabel + '</span>';
    descEl.parentNode.insertBefore(meter, descEl.nextSibling);
  };

  /* ============================================
     42. CART UPSELL
     ============================================ */
  HM.injectCartUpsell = function() {
    var cartDrawer = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
    if (!cartDrawer) return;
    var upsell = document.createElement('div');
    upsell.className = 'hm-cart-upsell';
    upsell.innerHTML = '<h4>You might also like</h4>';
    cartDrawer.appendChild(upsell);

    // Fetch best-selling coffee for upsell
    fetch('/collections/roasted-coffee/products.json?limit=3')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = (data.products || []).slice(0, 2);
        products.forEach(function(p) {
          var img = p.images && p.images[0] ? p.images[0].src : '';
          var price = p.variants && p.variants[0] ? '$' + (parseFloat(p.variants[0].price)).toFixed(2) : '';
          var item = document.createElement('a');
          item.href = '/products/' + p.handle;
          item.className = 'hm-cart-upsell-item';
          item.innerHTML = '<img src="' + img + '" alt="' + p.title + '"><p>' + p.title.substring(0, 40) + '</p><span>' + price + '</span>';
          upsell.appendChild(item);
        });
      })
      .catch(function() {});
  };

  /* ============================================
     43. GIFT CARD PROMO — DISABLED (P1)
     Gift cards belong in footer or a secondary merchandising area.
     ============================================ */
  HM.injectGiftCardPromo = function() {};

  /* ============================================
     44. SEASONAL BANNER — DISABLED (P1)
     Seasonal banners belong in the announcement bar, not as a homepage section.
     ============================================ */
  HM.injectSeasonalBanner = function() {};

  /* ============================================
     45. ENHANCED INIT (Phase 5-10 additions)
     ============================================ */
  var origInit2 = HM.init;
  

  /* ============================================
     46. SEO: ADD STRUCTURED DATA (JSON-LD)
     ============================================ */
  HM.injectStructuredData = function() {
    if (window.location.pathname.includes('/products/')) {
      // Product schema
      var script = document.createElement('script');
      script.type = 'application/ld+json';
      var title = document.querySelector('h1');
      var titleText = title ? title.textContent.trim() : document.title;
      var priceEl = document.querySelector('.price__regular .price-item, .price-item--regular');
      var price = priceEl ? priceEl.textContent.replace(/[^0-9.]/g, '') : '';
      var img = document.querySelector('meta[property="og:image"]');
      var imgSrc = img ? img.content : '';
      var desc = document.querySelector('meta[property="og:description"]');
      var descText = desc ? desc.content : '';
      script.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        "name": titleText,
        "image": imgSrc,
        "description": descText,
        "brand": { "@type": "Brand", "name": "Harvest Market" },
        "offers": {
          "@type": "Offer",
          "price": price,
          "priceCurrency": "USD",
          "availability": "https://schema.org/InStock"
        }
      });
      document.head.appendChild(script);
    } else if (window.location.pathname === '/') {
      // WebSite schema with search action
      var ws = document.createElement('script');
      ws.type = 'application/ld+json';
      ws.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Harvest Market Coffee & Tea",
        "url": "https://www.harvestmarket.coffee",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://www.harvestmarket.coffee/search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      });
      document.head.appendChild(ws);
    }
  };

  /* ============================================
     47. PERFORMANCE: PRELOAD KEY RESOURCES
     ============================================ */
  HM.preloadResources = function() {
    // Preload hero banner images
    if (window.location.pathname === '/') {
      for (var i = 1; i <= 3; i++) {
        var link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = '/cdn/shop/t/24/assets/hero-banner-' + i + '.png';
        document.head.appendChild(link);
      }
    }
  };

  /* ============================================
     48. IMAGE OPTIMIZATION: RESPONSIVE SIZES
     ============================================ */
  HM.optimizeImages = function() {
    var imgs = document.querySelectorAll('img:not([sizes]):not([width])');
    imgs.forEach(function(img) {
      if (!img.hasAttribute('src') || img.src.includes('cdn/shop')) {
        img.setAttribute('loading', img.getAttribute('loading') || 'lazy');
        img.setAttribute('decoding', 'async');
      }
    });
  };

  /* ============================================
     49. ACCESSIBILITY: SKIP LINK, ARIA
     ============================================ */
  HM.enhanceAccessibility = function() {
    // Skip to content link
    var skip = document.createElement('a');
    skip.href = '#MainContent';
    skip.textContent = 'Skip to content';
    skip.style.cssText = 'position:absolute;top:-40px;left:0;background:#d4af37;color:#1a1230;padding:8px 16px;z-index:9999;transition:top 0.2s';
    skip.addEventListener('focus', function() { this.style.top = '0'; });
    skip.addEventListener('blur', function() { this.style.top = '-40px'; });
    document.body.insertBefore(skip, document.body.firstChild);

    // Add aria labels to icon buttons
    var iconBtns = document.querySelectorAll('button:not([aria-label]):not([aria-labelledby])');
    iconBtns.forEach(function(btn) {
      var svg = btn.querySelector('svg');
      if (svg && !btn.textContent.trim()) {
        btn.setAttribute('aria-label', 'Button');
      }
    });
  };

  /* ============================================
     50. DARK MODE AUTO-DETECT
     ============================================ */
  HM.enhanceDarkMode = function() {
    // If no preference stored and system prefers dark, keep dark
    if (!localStorage.getItem('hm-theme')) {
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        document.documentElement.classList.add('theme-dark');
        document.documentElement.classList.remove('theme-light');
      }
    }
  };

  /* ============================================
     51. CART COUNT BADGE
     ============================================ */
  HM.injectCartBadge = function() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var count = cart.item_count;
      if (count > 0) {
        var cartLink = document.querySelector('a[href*="/cart"], .header__icon--cart');
        if (cartLink && !cartLink.querySelector('.hm-cart-badge')) {
          var badge = document.createElement('span');
          badge.className = 'hm-cart-badge';
          badge.style.cssText = 'position:absolute;top:-4px;right:-4px;background:#d4af37;color:#1a1230;border-radius:50%;width:18px;height:18px;font-size:0.65rem;font-weight:700;display:flex;align-items:center;justify-content:center';
          badge.textContent = count;
          cartLink.style.position = 'relative';
          cartLink.appendChild(badge);
        }
      }
    }).catch(function() {});
  };

  /* ============================================
     52. WISHLIST PERSISTENCE
     ============================================ */
  HM.initWishlist = function() {
    window.HM_WISHLIST = {
      get: function() {
        try { return JSON.parse(localStorage.getItem('hm_wishlist') || '[]'); } catch(e) { return []; }
      },
      add: function(handle) {
        var list = this.get();
        if (list.indexOf(handle) === -1) list.push(handle);
        try { localStorage.setItem('hm_wishlist', JSON.stringify(list)); } catch(e) {}
      },
      remove: function(handle) {
        var list = this.get().filter(function(h) { return h !== handle; });
        try { localStorage.setItem('hm_wishlist', JSON.stringify(list)); } catch(e) {}
      },
      has: function(handle) {
        return this.get().indexOf(handle) !== -1;
      }
    };
  };

  /* ============================================
     53. COMPARE PRODUCTS
     ============================================ */
  HM.initCompare = function() {
    var compareBtns = document.querySelectorAll('.hm-compare-btn');
    compareBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var handle = btn.dataset.handle;
        var compare = [];
        try { compare = JSON.parse(localStorage.getItem('hm_compare') || '[]'); } catch(e) {}
        if (compare.indexOf(handle) === -1 && compare.length < 4) {
          compare.push(handle);
          localStorage.setItem('hm_compare', JSON.stringify(compare));
          HM.toast('Added to compare');
        }
      });
    });
  };

  /* ============================================
     54. QUICK VIEW MODAL
     ============================================ */
  HM.initQuickView = function() {
    document.querySelectorAll('.hm-quick-view-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var handle = btn.dataset.handle;
        if (!handle) return;
        fetch('/products/' + handle + '.json')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var p = data.product;
            var overlay = document.createElement('div');
            overlay.className = 'hm-search-overlay active';
            var price = p.variants && p.variants[0] ? '$' + (parseFloat(p.variants[0].price)).toFixed(2) : '';
            var img = p.images && p.images[0] ? p.images[0].src : '';
            overlay.innerHTML = '<div class="hm-search-modal" style="max-width:500px;margin-top:60px"><div style="background:rgba(20,20,22,0.95);border-radius:12px;padding:0;overflow:hidden;border:1px solid rgba(212,175,55,0.2)">' +
              '<img src="' + img + '" alt="' + p.title + '" style="width:100%;height:250px;object-fit:cover">' +
              '<div style="padding:1.5rem"><h3 style="color:#f1e9d2;font-family:var(--font-heading-family,Assistant,sans-serif);margin:0 0 0.5rem">' + p.title + '</h3>' +
              '<p style="color:#d4af37;font-weight:600;margin:0 0 0.5rem">' + price + '</p>' +
              '<p style="color:rgba(241,233,210,0.6);font-size:0.85rem">' + (p.body_html || '').replace(/<[^>]+>/g,'').substring(0,200) + '</p>' +
              '<a href="/products/' + p.handle + '" style="display:inline-block;margin-top:1rem;padding:0.65rem 1.5rem;background:#d4af37;color:#1a1230;border-radius:999px;font-weight:600;text-decoration:none">View Full Details</a></div></div></div>';
            document.body.appendChild(overlay);
            overlay.addEventListener('click', function(e) {
              if (e.target === overlay) overlay.remove();
            });
          });
      });
    });
  };

  /* ============================================
     55. FINAL INIT (Phase 7-10 additions)
     ============================================ */
  var origInit3 = HM.init;
  

  /* ============================================
     56. HOMEPAGE LAYOUT REORDER (coffee first)
     ============================================ */
  HM.reorderHomepage = function() {
    if (window.location.pathname !== '/') return;
    // Move featured coffee section (featured_all_brands) before three brand cards
    var brandCards = document.querySelector('#shopify-section-template\\--26123882856760__three_brand_cards_8bJPPA, [id*="three_brand_cards"]');
    var featuredCoffee = document.querySelector('#shopify-section-template\\--26123882856760__featured_all_brands_eyXXc8, [id*="featured_all_brands_eyXXc8"]');
    if (brandCards && featuredCoffee && brandCards.parentNode) {
      brandCards.parentNode.insertBefore(featuredCoffee, brandCards);
    }
  };

  /* ============================================
     57. PRODUCT COUNT ON COLLECTIONS
     ============================================ */
  HM.enhanceCollectionHeader = function() {
    if (!window.location.pathname.includes('/collections/')) return;
    var grid = document.querySelector('#product-grid, .product-grid');
    if (!grid) return;
    var count = grid.querySelectorAll('li, .grid__item').length;
    var heading = document.querySelector('.collection-hero__title, h1');
    if (heading && !heading.querySelector('.hm-count-badge')) {
      var badge = document.createElement('span');
      badge.className = 'hm-count-badge';
      badge.style.cssText = 'display:inline-block;margin-left:8px;padding:2px 10px;background:rgba(212,175,55,0.2);color:#d4af37;border-radius:999px;font-size:0.8rem;font-weight:600';
      badge.textContent = count + ' products';
      heading.appendChild(badge);
    }
  };

  /* ============================================
     58. PDP IMAGE BADGES (on product cards)
     ============================================ */
  HM.addProductCardBadges = function() {
    var cards = document.querySelectorAll('.card, .product-card, .card--product');
    cards.forEach(function(card) {
      if (card.dataset.hmBadged) return;
      card.dataset.hmBadged = '1';
      var titleEl = card.querySelector('.card__heading, .product__title, a[href*="/products/"]');
      var title = titleEl ? titleEl.textContent.toLowerCase() : '';
      if (title.includes('pre-order') || title.includes('preorder')) {
        if (!card.querySelector('.hm-product-badge')) {
          var b = document.createElement('span');
          b.className = 'hm-product-badge hm-badge-preorder';
          b.textContent = 'Pre-Order';
          card.appendChild(b);
        }
      }
    });
  };

  /* ============================================
     59. CART PAGE ENHANCEMENTS
     ============================================ */
  HM.enhanceCartPage = function() {
    if (window.location.pathname !== '/cart') return;
    // Add trust badges below checkout button
    var checkoutBtn = document.querySelector('button[name="checkout"], .cart__checkout-button, a[href*="/checkout"]');
    if (checkoutBtn && !document.querySelector('.hm-cart-trust')) {
      var trust = document.createElement('div');
      trust.className = 'hm-cart-trust';
      trust.style.cssText = 'display:flex;justify-content:center;gap:1rem;padding:1rem;flex-wrap:wrap';
      trust.innerHTML = [
        '<div class="hm-pdp-trust-item"><svg viewBox="0 0 24 24" style="width:16px;height:16px;fill:#d4af37"><path d="M12 2L4 5v6c0 5.5 3.8 10.7 8 12 4.2-1.3 8-6.5 8-12V5l-8-3z"/></svg> Secure Checkout</div>',
        '<div class="hm-pdp-trust-item"><svg viewBox="0 0 24 24" style="width:16px;height:16px;fill:#d4af37"><path d="M20 8h-3V4H5v16h12v-4h3V8z"/></svg> Encrypted</div>',
        '<div class="hm-pdp-trust-item"><svg viewBox="0 0 24 24" style="width:16px;height:16px;fill:#d4af37"><path d="M12 1L3 5v6c0 5.6 3.8 10.7 9 12 5.2-1.3 9-6.4 9-12V5l-9-4z"/></svg> Protected</div>'
      ].join('');
      checkoutBtn.parentNode.appendChild(trust);
    }
  };

  /* ============================================
     60. BLOG/ARTICLE ENHANCEMENTS
     ============================================ */
  HM.enhanceArticle = function() {
    if (!window.location.pathname.includes('/blogs/')) return;
    // Add reading time
    var article = document.querySelector('article, .article, .rte, .blog-post-content, .article-template__content');
    if (!article || document.querySelector('.hm-reading-time')) return;
    var text = article.textContent || '';
    var words = text.split(/\s+/).length;
    var minutes = Math.ceil(words / 200);
    var titleEl = document.querySelector('.article__title, h1');
    if (titleEl) {
      var rt = document.createElement('div');
      rt.className = 'hm-reading-time';
      rt.style.cssText = 'color:rgba(241,233,210,0.4);font-size:0.8rem;margin-top:0.3rem';
      rt.textContent = '\u23F1 ' + minutes + ' min read \u00B7 ' + words + ' words';
      titleEl.parentNode.insertBefore(rt, titleEl.nextSibling);
    }
    // Add share buttons
    var shareBar = document.createElement('div');
    shareBar.className = 'hm-article-share';
    shareBar.style.cssText = 'display:flex;flex-direction:row;gap:0.5rem;flex-wrap:wrap;margin:1.5rem 0;align-items:center';
    var shareLabel = document.createElement('span');
    shareLabel.style.cssText = 'font-size:0.9rem;font-weight:600;margin-right:0.5rem';
    shareLabel.textContent = 'Share:';
    shareBar.appendChild(shareLabel);
    var tweet = document.createElement('a');
    tweet.href = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(window.location.href);
    tweet.target = '_blank';
    tweet.rel = 'noopener';
    tweet.style.cssText = 'display:inline-flex;align-items:center;gap:0.3rem;padding:0.5rem 1rem;border-radius:999px;font-size:0.9rem;text-decoration:none;border:1px solid rgba(212,175,55,0.3);background:rgba(212,175,55,0.05);color:inherit;transition:all 0.2s ease';
    tweet.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg> Share on X';
    shareBar.appendChild(tweet);
    var fb = document.createElement('a');
    fb.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location.href);
    fb.target = '_blank';
    fb.rel = 'noopener';
    fb.style.cssText = 'display:inline-flex;align-items:center;gap:0.3rem;padding:0.5rem 1rem;border-radius:999px;font-size:0.9rem;text-decoration:none;border:1px solid rgba(212,175,55,0.3);background:rgba(212,175,55,0.05);color:inherit;transition:all 0.2s ease';
    fb.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg> Share on Facebook';
    shareBar.appendChild(fb);
    // Insert share bar after the article content
    var insertTarget = article.parentNode;
    if (article.nextElementSibling) {
      insertTarget.insertBefore(shareBar, article.nextElementSibling);
    } else {
      insertTarget.appendChild(shareBar);
    }
  };

  /* ============================================
     61. FOOTER ENHANCEMENTS
     ============================================ */
  HM.enhanceFooter = function() {
    var footer = document.querySelector('.shopify-section-group-footer-group, footer');
    if (!footer || document.querySelector('.hm-footer-enhanced')) return;
    footer.classList.add('hm-footer-enhanced');
    // Add payment icons
    var payDiv = document.createElement('div');
    payDiv.style.cssText = 'display:flex;justify-content:center;gap:8px;padding:1rem;flex-wrap:wrap';
    payDiv.innerHTML = [
      '<span style="background:#fff;color:#1a1a1a;padding:2px 8px;border-radius:4px;font-size:0.7rem;font-weight:600">VISA</span>',
      '<span style="background:#fff;color:#1a1a1a;padding:2px 8px;border-radius:4px;font-size:0.7rem;font-weight:600">MC</span>',
      '<span style="background:#fff;color:#1a1a1a;padding:2px 8px;border-radius:4px;font-size:0.7rem;font-weight:600">AMEX</span>',
      '<span style="background:#fff;color:#1a1a1a;padding:2px 8px;border-radius:4px;font-size:0.7rem;font-weight:600">DISC</span>',
      '<span style="background:#000;color:#fff;padding:2px 8px;border-radius:4px;font-size:0.7rem;font-weight:600">PayPal</span>',
      '<span style="background:#5a31f4;color:#fff;padding:2px 8px;border-radius:4px;font-size:0.7rem;font-weight:600">Shop Pay</span>',
      '<span style="background:#fff;color:#1a1a1a;padding:2px 8px;border-radius:4px;font-size:0.7rem;font-weight:600">Apple Pay</span>',
      '<span style="background:#fff;color:#1a1a1a;padding:2px 8px;border-radius:4px;font-size:0.7rem;font-weight:600">G Pay</span>'
    ].join('');
    footer.appendChild(payDiv);
  };

  /* ============================================
     62. PAGE TRANSITION LOADER
     ============================================ */
  HM.initPageLoader = function() {
    var loader = document.createElement('div');
    loader.id = 'hm-page-loader';
    loader.style.cssText = 'position:fixed;top:0;left:0;right:0;height:3px;background:transparent;z-index:99998';
    var bar = document.createElement('div');
    bar.style.cssText = 'height:100%;width:0%;background:linear-gradient(90deg,#d4af37,#e0b840);transition:width 0.3s';
    loader.appendChild(bar);
    document.body.appendChild(loader);

    document.addEventListener('click', function(e) {
      var link = e.target.closest('a[href]');
      if (!link) return;
      if (link.target === '_blank') return;
      if (link.href.startsWith('javascript:')) return;
      if (link.href.startsWith('#')) return;
      if (link.href.startsWith('tel:') || link.href.startsWith('mailto:')) return;
      if (link.href.indexOf(window.location.origin) === -1) return;
      if (link.href === window.location.href) return;
      // Start loading animation
      bar.style.width = '30%';
      setTimeout(function() { bar.style.width = '70%'; }, 200);
    });

    window.addEventListener('load', function() {
      bar.style.width = '100%';
      setTimeout(function() { bar.style.width = '0%'; }, 500);
    });
  };

  /* ============================================
     63. SCROLL-TO-PRODUCT ON COLLECTION
     ============================================ */
  HM.enhanceCollectionScroll = function() {
    if (!window.location.pathname.includes('/collections/')) return;
    var url = new URL(window.location);
    if (url.searchParams.has('scroll')) {
      var target = document.querySelector('#product-grid, .product-grid');
      if (target) {
        setTimeout(function() { target.scrollIntoView({ behavior: 'smooth' }); }, 500);
      }
    }
  };

  /* ============================================
     64. PRODUCT TABS (PDP)
     ============================================ */
  HM.injectProductTabs = function() {
    var desc = document.querySelector('.product__description, .rte, .product-description');
    if (!desc || document.querySelector('.hm-product-tabs')) return;
    var accordion = document.querySelector('details, .accordion');
    if (accordion) return; // Don't duplicate if Dawn already has accordion

    var tabs = document.createElement('div');
    tabs.className = 'hm-product-tabs';
    tabs.style.cssText = 'margin:2rem 0;border-top:1px solid rgba(212,175,55,0.1)';
    tabs.innerHTML = [
      '<div style="display:flex;gap:1rem;border-bottom:1px solid rgba(212,175,55,0.1);padding-bottom:0.5rem">',
      '<button class="hm-tab-btn active" data-tab="desc" style="background:none;border:none;color:#d4af37;font-weight:600;cursor:pointer;padding:0.5rem 0;font-size:0.9rem">Description</button>',
      '<button class="hm-tab-btn" data-tab="shipping" style="background:none;border:none;color:rgba(241,233,210,0.4);font-weight:600;cursor:pointer;padding:0.5rem 0;font-size:0.9rem">Shipping</button>',
      '<button class="hm-tab-btn" data-tab="returns" style="background:none;border:none;color:rgba(241,233,210,0.4);font-weight:600;cursor:pointer;padding:0.5rem 0;font-size:0.9rem">Returns</button>',
      '</div>',
      '<div class="hm-tab-content" data-tab="desc" style="padding:1rem 0;color:rgba(241,233,210,0.7);font-size:0.9rem;line-height:1.6">' + desc.innerHTML + '</div>',
      '<div class="hm-tab-content" data-tab="shipping" style="padding:1rem 0;color:rgba(241,233,210,0.7);font-size:0.9rem;line-height:1.6;display:none"><p>Orders are processed and shipped within 1-3 business days. Coffee is roasted to order for maximum freshness.</p><p>Free shipping on orders over $50 within the United States.</p></div>',
      '<div class="hm-tab-content" data-tab="returns" style="padding:1rem 0;color:rgba(241,233,210,0.7);font-size:0.9rem;line-height:1.6;display:none"><p>Not satisfied? Contact us within 30 days for a replacement or refund. Your satisfaction is our priority.</p></div>'
    ].join('');

    desc.style.display = 'none';
    desc.parentNode.insertBefore(tabs, desc.nextSibling);

    tabs.querySelectorAll('.hm-tab-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        tabs.querySelectorAll('.hm-tab-btn').forEach(function(b) { b.classList.remove('active'); b.style.color = 'rgba(241,233,210,0.4)'; });
        btn.classList.add('active');
        btn.style.color = '#d4af37';
        tabs.querySelectorAll('.hm-tab-content').forEach(function(c) { c.style.display = 'none'; });
        var content = tabs.querySelector('.hm-tab-content[data-tab="' + btn.dataset.tab + '"]');
        if (content) content.style.display = 'block';
      });
    });
  };

  /* ============================================
     65. ULTIMATE INIT (all phases)
     ============================================ */
  var origInit4 = HM.init;
  

  // Auto-init
  /* auto-init deferred to v3 additions */
})();



/* Harvest Market Enhancement System v3.1 - Additional JS */
/* Phase 11-15: Micro-interactions, polish, and more features */
(function() {
  'use strict';
  var HM = window.HM || {};
  window.HM = HM;

  /* ============================================
     66. IMAGE LAZY LOAD FADE-IN
     ============================================ */
  HM.initImageFadeIn = function() {
    if (!('IntersectionObserver' in window)) return;
    var images = document.querySelectorAll('img[loading="lazy"]');
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('loaded');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '50px' });
    images.forEach(function(img) { observer.observe(img); });
    // Also mark already-loaded images
    images.forEach(function(img) {
      if (img.complete) img.classList.add('loaded');
      img.addEventListener('load', function() { img.classList.add('loaded'); });
    });
  };

  /* ============================================
     67. BUTTON LOADING STATES
     ============================================ */
  HM.initButtonLoading = function() {
    document.querySelectorAll('button[type="submit"], form button[type="submit"]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.form && btn.form.checkValidity()) {
          btn.classList.add('hm-btn-loading');
          setTimeout(function() { btn.classList.remove('hm-btn-loading'); }, 3000);
        }
      });
    });
  };

  /* ============================================
     68. COFFEE ORIGIN MAP (PDP)
     ============================================ */
  HM.injectOriginMap = function() {
    var desc = document.querySelector('meta[property="og:description"]');
    if (!desc || !desc.content.toLowerCase().includes('coffee')) return;
    var descEl = document.querySelector('.product__description, .rte');
    if (!descEl || document.querySelector('.hm-origin-map')) return;

    var text = desc.content;
    var origins = [];
    var patterns = [
      { regex: /colombia/i, label: 'Colombia' },
      { regex: /costa rica/i, label: 'Costa Rica' },
      { regex: /ethiopia/i, label: 'Ethiopia' },
      { regex: /sumatra|indonesia/i, label: 'Indonesia' },
      { regex: /burundi/i, label: 'Burundi' },
      { regex: /java/i, label: 'Java' },
      { regex: /kenya/i, label: 'Kenya' },
      { regex: /guatemala/i, label: 'Guatemala' },
      { regex: /brazil/i, label: 'Brazil' },
      { regex: /panama/i, label: 'Panama' },
      { regex: /rwanda/i, label: 'Rwanda' },
      { regex: /yemen/i, label: 'Yemen' }
    ];
    patterns.forEach(function(p) {
      if (p.regex.test(text)) origins.push(p.label);
    });

    if (origins.length === 0) return;
    var map = document.createElement('div');
    map.className = 'hm-origin-map';
    origins.forEach(function(o) {
      var pin = document.createElement('span');
      pin.className = 'hm-origin-pin';
      pin.textContent = o;
      map.appendChild(pin);
    });
    descEl.parentNode.insertBefore(map, descEl.nextSibling);
  };

  /* ============================================
     69. SUBSCRIPTION PROMO (PDP for coffee)
     ============================================ */
  HM.injectSubPromo = function() {
    var desc = document.querySelector('meta[property="og:description"]');
    if (!desc || !desc.content.toLowerCase().includes('coffee')) return;
    var form = document.querySelector('product-form, form[action*="/cart/add"]');
    if (!form || document.querySelector('.hm-sub-promo')) return;

    var promo = document.createElement('div');
    promo.className = 'hm-sub-promo';
    promo.innerHTML = '<div class="hm-sp-icon">\u23F1</div><div><h3>Subscribe & Save</h3><p>Never run out. Get fresh coffee delivered monthly. Cancel anytime.</p><a href="/products/roasters-choice-artisanal-micro-lot-coffee-club">Join Coffee Club</a></div>';
    form.parentNode.insertBefore(promo, form);
  };

  /* ============================================
     70. MAGNIFY PRODUCT IMAGES ON HOVER
     ============================================ */
  HM.initImageMagnify = function() {
    if (window.innerWidth < 768) return; // Desktop only
    var images = document.querySelectorAll('.product__media img, .product-media img');
    images.forEach(function(img) {
      if (img.dataset.hmMagnify) return;
      img.dataset.hmMagnify = '1';
      var zoom = 1;
      img.addEventListener('mouseenter', function() {
        img.style.transition = 'transform 0.3s ease';
        img.style.transform = 'scale(1.3)';
      });
      img.addEventListener('mouseleave', function() {
        img.style.transform = 'scale(1)';
      });
      img.addEventListener('mousemove', function(e) {
        var rect = img.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });
    });
  };

  /* ============================================
     71. PDP RATING STARS — DISABLED
     Fake 5-star "Based on reviews" with no actual reviews misleads customers. Removed P0.
     ============================================ */
  HM.injectRatingStars = function() {
    // Disabled: showing 5 stars with "(Based on reviews)" but no actual reviews
    // is misleading. Enable when real reviews are collected via Judge.me or similar.
    return;
  };

  /* ============================================
     72. QUANTITY SELECTOR ENHANCEMENT
     ============================================ */
  HM.enhanceQuantitySelector = function() {
    var qtyInputs = document.querySelectorAll('input[name="quantity"], .quantity__input');
    qtyInputs.forEach(function(input) {
      if (input.dataset.hmEnhanced) return;
      input.dataset.hmEnhanced = '1';
      input.style.cssText += 'border:1px solid rgba(212,175,55,0.3);border-radius:8px;padding:8px 12px;text-align:center;font-weight:600;color:#f1e9d2;background:rgba(255,255,255,0.05)';
    });
  };

  /* ============================================
     73. VARIANT SELECTOR POLISH
     ============================================ */
  HM.enhanceVariantSelector = function() {
    var variants = document.querySelectorAll('variant-selects, variant-radios, .variant-input');
    variants.forEach(function(v) {
      if (v.dataset.hmEnhanced) return;
      v.dataset.hmEnhanced = '1';
      v.style.cssText += 'border-radius:8px';
    });
    // Style radio/checkbox labels
    var labels = document.querySelectorAll('.variant__label, .product-form__input label');
    labels.forEach(function(l) {
      l.style.cssText += 'color:rgba(241,233,210,0.7);font-weight:600;font-size:0.85rem;text-transform:uppercase;letter-spacing:0.05em';
    });
  };

  /* ============================================
     74. BREADCRUMB JSON-LD SCHEMA
     ============================================ */
  HM.injectBreadcrumbSchema = function() {
    if (window.location.pathname === '/') return;
    var path = window.location.pathname.split('/').filter(Boolean);
    if (path.length < 2) return;

    var items = [{ "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.harvestmarket.coffee" }];
    var url = '';
    for (var i = 0; i < path.length; i++) {
      url += '/' + path[i];
      var name = path[i].replace(/-/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
      items.push({ "@type": "ListItem", "position": i + 2, "name": name, "item": "https://www.harvestmarket.coffee" + url });
    }

    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": items
    });
    document.head.appendChild(script);
  };

  /* ============================================
     75. COLLECTION PAGE JSON-LD
     ============================================ */
  HM.injectCollectionSchema = function() {
    if (!window.location.pathname.includes('/collections/')) return;
    var title = document.querySelector('h1');
    var titleText = title ? title.textContent.trim() : 'Collection';
    var desc = document.querySelector('meta[name="description"]');
    var descText = desc ? desc.content : '';

    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": titleText,
      "description": descText,
      "url": window.location.href
    });
    document.head.appendChild(script);
  };

  /* ============================================
     76. PRODUCT AVAILABILITY SCHEMA
     ============================================ */
  HM.injectAvailabilitySchema = function() {
    if (!window.location.pathname.includes('/products/')) return;
    var soldOut = document.querySelector('.product__sold-out, .price__sold-out, [data-sold-out]');
    var availability = soldOut ? "https://schema.org/OutOfStock" : "https://schema.org/InStock";

    // Add to existing product schema or create new
    var existing = document.querySelector('script[type="application/ld+json"]');
    if (existing) {
      try {
        var data = JSON.parse(existing.textContent);
        if (data["@type"] === "Product" && data.offers) {
          data.offers.availability = availability;
          existing.textContent = JSON.stringify(data);
        }
      } catch(e) {}
    }
  };

  /* ============================================
     77. HOMEPAGE COFFEE COMPARISON TABLE — DISABLED (P1)
     Comparison table belongs on the collection page, not the homepage.
     ============================================ */
  HM.injectCoffeeComparison = function() {};

  /* ============================================
     78. MOBILE GESTURES: LONG PRESS FOR WISHLIST
     ============================================ */
  HM.initLongPressWishlist = function() {
    if (window.innerWidth >= 768) return;
    var cards = document.querySelectorAll('.card, .product-card, .card--product');
    cards.forEach(function(card) {
      if (card.dataset.hmLongPress) return;
      card.dataset.hmLongPress = '1';
      var timer = null;
      card.addEventListener('touchstart', function(e) {
        timer = setTimeout(function() {
          HM.toast('Added to wishlist!');
          var wish = card.querySelector('.hm-wishlist-btn');
          if (wish) wish.classList.add('active');
          // Haptic feedback
          if (navigator.vibrate) navigator.vibrate(50);
        }, 600);
      }, { passive: true });
      card.addEventListener('touchend', function() { clearTimeout(timer); });
      card.addEventListener('touchmove', function() { clearTimeout(timer); });
    });
  };

  /* ============================================
     79. ANNOUNCEMENT BAR ROTATION
     ============================================ */
  HM.initRotatingAnnouncement = function() {
    var bar = document.querySelector('.hm-announcement');
    if (!bar || bar.dataset.hmRotating) return;
    bar.dataset.hmRotating = '1';
    var messages = [
      'Free shipping on orders over $50 \u00B7 <a href="/collections/roasted-coffee">Shop Coffee</a>',
      'Fresh roasted to order \u00B7 <a href="/pages/about-us">Our Story</a>',
      'New: Purple Caturra Blueberry Co-Ferment \u00B7 <a href="/products/colombia-finca-monteblanco-purple-caturra-blueberry-washed-co-ferment-1lb">Try it now</a>',
      'Subscribe & save \u00B7 <a href="/products/roasters-choice-artisanal-micro-lot-coffee-club">Join the Coffee Club</a>'
    ];
    var idx = 0;
    setInterval(function() {
      idx = (idx + 1) % messages.length;
      bar.style.opacity = '0';
      bar.style.transition = 'opacity 0.3s';
      setTimeout(function() {
        bar.innerHTML = messages[idx];
        bar.style.opacity = '1';
      }, 300);
    }, 5000);
  };

  /* ============================================
     80. DYNAMIC YEAR IN FOOTER
     ============================================ */
  HM.updateCopyrightYear = function() {
    var year = new Date().getFullYear();
    document.querySelectorAll('footer, .shopify-section-group-footer-group').forEach(function(f) {
      f.innerHTML = f.innerHTML.replace(/20\d\d(?=\s|<|&|<)/, year);
    });
  };

  /* ============================================
     81. INIT ALL NEW FEATURES
     ============================================ */
  var origInit5 = HM.init;
  

  /* ============================================
     82. HOMEPAGE COFFEE EDUCATION SECTION — DISABLED (P1)
     Educational content belongs on a dedicated /learn page, not the homepage.
     ============================================ */
  HM.injectCoffeeEducation = function() {};

  HM.injectFreshnessIndicator = function() {
    var desc = document.querySelector('meta[property="og:description"]');
    if (!desc || !desc.content.toLowerCase().includes('coffee')) return;
    var form = document.querySelector('product-form, form[action*="/cart/add"]');
    if (!form || document.querySelector('.hm-freshness')) return;
    var indicator = document.createElement('div');
    indicator.className = 'hm-freshness';
    indicator.style.cssText = 'display:flex;align-items:center;gap:8px;padding:8px 12px;background:rgba(28,106,79,0.1);border-radius:8px;margin:0.5rem 0;font-size:0.8rem';
    indicator.innerHTML = '<span class="hm-live-dot"></span> <span style="color:rgba(241,233,210,0.7)">Roasted to order for maximum freshness</span>';
    form.parentNode.insertBefore(indicator, form);
  };

  HM.injectPDPShare = function() {
    if (!window.location.pathname.includes('/products/')) return;
    var form = document.querySelector('product-form, form[action*="/cart/add"]');
    if (!form || document.querySelector('.hm-pdp-share')) return;
    var url = encodeURIComponent(window.location.href);
    var title = encodeURIComponent(document.title);
    var share = document.createElement('div');
    share.className = 'hm-pdp-share';
    share.style.cssText = 'display:flex;align-items:center;gap:8px;margin:1rem 0;padding-top:1rem;border-top:1px solid rgba(212,175,55,0.1)';
    share.innerHTML = '<span style="color:rgba(241,233,210,0.5);font-size:0.85rem;margin-right:4px">Share:</span>' +
      '<a href="https://twitter.com/intent/tweet?url=' + url + '&text=' + title + '" target="_blank" style="padding:6px 12px;background:rgba(255,255,255,0.05);border-radius:8px;color:#1DA1F2;font-size:0.8rem;text-decoration:none">Share on X</a>' +
      '<a href="https://www.facebook.com/sharer/sharer.php?u=' + url + '" target="_blank" style="padding:6px 12px;background:rgba(255,255,255,0.05);border-radius:8px;color:#4267B2;font-size:0.8rem;text-decoration:none">Facebook</a>' +
      '<a href="https://pinterest.com/pin/create/button/?url=' + url + '" target="_blank" style="padding:6px 12px;background:rgba(255,255,255,0.05);border-radius:8px;color:#E60023;font-size:0.8rem;text-decoration:none">Pin It</a>';
    form.parentNode.insertBefore(share, form.nextSibling);
  };

  HM.enhanceCollectionTitle = function() {
    if (!window.location.pathname.includes('/collections/')) return;
    var title = document.querySelector('.collection-hero__title, h1');
    if (!title || title.dataset.hmEnhanced) return;
    title.dataset.hmEnhanced = '1';
    var grid = document.querySelector('#product-grid, .product-grid');
    if (grid) {
      var count = grid.querySelectorAll('li, .grid__item').length;
      var subtitle = document.createElement('p');
      subtitle.style.cssText = 'color:rgba(241,233,210,0.5);font-size:0.9rem;margin:0.3rem 0';
      subtitle.textContent = 'Showing ' + count + ' products';
      title.parentNode.insertBefore(subtitle, title.nextSibling);
    }
  };

  HM.injectCollectionCards = function() {
    if (window.location.pathname !== '/') return;
    var stats = document.querySelector('.hm-stats-bar');
    if (!stats || document.querySelector('.hm-collection-cards')) return;
    var section = document.createElement('div');
    section.className = 'hm-collection-cards';
    section.style.cssText = 'padding:40px 20px;max-width:1200px;margin:0 auto';
    section.innerHTML = '<h2 style="font-family:var(--font-heading-family,Assistant,sans-serif);font-size:1.8rem;color:#f1e9d2;text-align:center;margin-bottom:1.5rem">Shop by Category</h2><div id="hmCatGrid" style="display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:1rem"></div>';
    stats.parentNode.insertBefore(section, stats.nextSibling);
    var cats = [
      { name: 'Roasted Coffee', handle: 'roasted-coffee', icon: '\u2615', count: 31 },
      { name: 'Mushroom Coffee', handle: 'shroomffee-coffee', icon: '\u2618', count: 19 },
      { name: 'T-Shirts', handle: 't-shirts', icon: '\u2615', count: 106 },
      { name: 'Mugs', handle: 'mug', icon: '\u2615', count: 142 },
      { name: 'Hoodies', handle: 'hoodies', icon: '\u2615', count: 55 },
      { name: 'Stickers', handle: 'stickers', icon: '\u2615', count: 102 }
    ];
    var grid = section.querySelector('#hmCatGrid');
    cats.forEach(function(c) {
      var card = document.createElement('a');
      card.href = '/collections/' + c.handle;
      card.style.cssText = 'display:block;padding:1.5rem;text-align:center;background:rgba(255,255,255,0.02);border:1px solid rgba(212,175,55,0.1);border-radius:12px;text-decoration:none;transition:all 0.3s ease';
      card.innerHTML = '<div style="font-size:2rem;margin-bottom:0.5rem">' + c.icon + '</div><div style="color:#f1e9d2;font-weight:600;font-size:0.9rem">' + c.name + '</div><div style="color:rgba(212,175,55,0.6);font-size:0.75rem;margin-top:0.2rem">' + c.count + ' products</div>';
      card.addEventListener('mouseenter', function() { card.style.transform = 'translateY(-4px)'; card.style.borderColor = 'rgba(212,175,55,0.3)'; });
      card.addEventListener('mouseleave', function() { card.style.transform = ''; card.style.borderColor = 'rgba(212,175,55,0.1)'; });
      grid.appendChild(card);
    });
  };

  HM.injectProcessingInfo = function() {
    var desc = document.querySelector('meta[property="og:description"]');
    if (!desc || !desc.content.toLowerCase().includes('coffee')) return;
    var descEl = document.querySelector('.product__description, .rte');
    if (!descEl || document.querySelector('.hm-processing-info')) return;
    var text = desc.content.toLowerCase();
    var methods = [];
    if (text.includes('washed')) methods.push({ name: 'Washed', desc: 'Cherry removed before drying, clean bright flavors' });
    if (text.includes('dry process') || text.includes('natural process')) methods.push({ name: 'Natural', desc: 'Dried with cherry on, fruity complex notes' });
    if (text.includes('honey')) methods.push({ name: 'Honey', desc: 'Partial cherry removal, sweet balanced cup' });
    if (text.includes('anaerobic')) methods.push({ name: 'Anaerobic', desc: 'Fermented in oxygen-free environment, unique flavors' });
    if (text.includes('co-ferment') || text.includes('coferment')) methods.push({ name: 'Co-Ferment', desc: 'Fermented with fruits, naturally flavored' });
    if (text.includes('wet hulled')) methods.push({ name: 'Wet Hulled', desc: 'Traditional Indonesian method, earthy body' });
    if (methods.length === 0) return;
    var info = document.createElement('div');
    info.className = 'hm-processing-info hm-pdp-section';
    info.innerHTML = '<h3>Processing Method</h3>' + methods.map(function(m) {
      return '<div style="display:flex;align-items:start;gap:8px;margin:0.5rem 0"><span style="color:#d4af37;font-weight:700;min-width:80px">' + m.name + '</span><span style="color:rgba(241,233,210,0.6);font-size:0.85rem">' + m.desc + '</span></div>';
    }).join('');
    descEl.parentNode.insertBefore(info, descEl.nextSibling);
  };

  var origInit7 = HM.init;
  

  /* ============================================
     89. HOMEPAGE BESTSELLERS SECTION
     ============================================ */
  HM.injectBestsellers = function() {
    if (window.location.pathname !== '/') return;
    var catCards = document.querySelector('.hm-collection-cards');
    if (!catCards || document.querySelector('.hm-bestsellers')) return;

    var section = document.createElement('div');
    section.className = 'hm-bestsellers hm-coffee-showcase';
    section.style.cssText = 'padding:40px 20px;background:transparent';
    section.innerHTML = '<h2 style="font-family:var(--font-heading-family,Assistant,sans-serif);font-size:1.8rem;color:#f1e9d2;text-align:center;margin-bottom:1.5rem">Best Sellers</h2><div id="hmBestGrid" style="display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:1rem;max-width:1200px;margin:0 auto"></div>';
    catCards.parentNode.insertBefore(section, catCards.nextSibling);

    var grid = section.querySelector('#hmBestGrid');
    if (!grid) return;

    // Fetch best-selling products from IN STOCK collection
    fetch('/collections/in-stock/products.json?limit=8')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = (data.products || []).slice(0, 4);
        products.forEach(function(p) {
          var img = p.images && p.images[0] ? p.images[0].src : '';
          var price = p.variants && p.variants[0] ? '$' + (parseFloat(p.variants[0].price)).toFixed(2) : '';
          var card = document.createElement('a');
          card.href = '/products/' + p.handle;
          card.className = 'hm-product-card-enhanced';
          card.style.cssText = 'display:block;border-radius:10px;overflow:hidden;text-decoration:none;transition:all 0.3s ease;background:rgba(255,255,255,0.02);border:1px solid rgba(212,175,55,0.1)';
          card.innerHTML = '<div style="position:relative;overflow:hidden"><img src="' + img + '" alt="' + p.title + '" loading="lazy" style="width:100%;height:180px;object-fit:cover;transition:transform 0.5s ease"><span class="hm-product-badge hm-badge-best" style="position:absolute;top:8px;left:8px">Best Seller</span></div><div style="padding:0.8rem"><div style="color:#f1e9d2;font-size:0.85rem;font-weight:600;margin-bottom:0.2rem">' + p.title.substring(0, 40) + '</div><div style="color:#d4af37;font-weight:700;font-size:0.9rem">' + price + '</div></div>';
          card.addEventListener('mouseenter', function() { card.style.transform = 'translateY(-4px)'; card.style.boxShadow = '0 8px 24px rgba(0,0,0,0.2)'; });
          card.addEventListener('mouseleave', function() { card.style.transform = ''; card.style.boxShadow = ''; });
          grid.appendChild(card);
        });
      })
      .catch(function() {});
  };

  /* ============================================
     90. PDP: BREWING RECOMMENDATION BASED ON ROAST
     ============================================ */
  HM.injectBrewRecommendation = function() {
    var desc = document.querySelector('meta[property="og:description"]');
    if (!desc || !desc.content.toLowerCase().includes('coffee')) return;
    var guide = document.querySelector('.hm-pdp-section');
    if (!guide || document.querySelector('.hm-brew-rec')) return;

    var text = desc.content.toLowerCase();
    var method = '';
    var methodIcon = '';
    var methodDesc = '';
    if (text.includes('light') || text.includes('bright') || text.includes('floral') || text.includes('citrus')) {
      method = 'Pour Over (V60)'; methodIcon = '\u2615'; methodDesc = '1:16 ratio, 30s bloom, 3:00 total, medium grind';
    } else if (text.includes('dark') || text.includes('earth') || text.includes('tobacco') || text.includes('rustic') || text.includes('pungent')) {
      method = 'French Press'; methodIcon = '\u267F'; methodDesc = '1:15 ratio, 4:00 steep, coarse grind';
    } else if (text.includes('medium') || text.includes('balanced') || text.includes('chocolate') || text.includes('caramel')) {
      method = 'Espresso'; methodIcon = '\u2698'; methodDesc = '1:2 ratio, 25-30s extraction, fine grind, 93C';
    } else {
      method = 'Any Method'; methodIcon = '\u2615'; methodDesc = 'This versatile coffee works well with any brewing method';
    }

    var rec = document.createElement('div');
    rec.className = 'hm-brew-rec';
    rec.style.cssText = 'padding:1rem;background:rgba(212,175,55,0.05);border:1px solid rgba(212,175,55,0.15);border-radius:10px;margin:0.5rem 0;display:flex;align-items:center;gap:1rem';
    rec.innerHTML = '<div style="font-size:1.8rem">' + methodIcon + '</div><div><div style="color:#d4af37;font-weight:700;font-size:0.9rem">Recommended Brew Method</div><div style="color:rgba(241,233,210,0.6);font-size:0.8rem;margin-top:0.2rem"><strong style="color:#f1e9d2">' + method + '</strong> - ' + methodDesc + '</div></div>';
    guide.parentNode.insertBefore(rec, guide.nextSibling);
  };

  /* ============================================
     91. PDP: CUPPING SCORE DISPLAY
     ============================================ */
  HM.injectCuppingScore = function() {
    var desc = document.querySelector('meta[property="og:description"]');
    if (!desc || !desc.content.toLowerCase().includes('coffee')) return;
    var descEl = document.querySelector('.product__description, .rte');
    if (!descEl || document.querySelector('.hm-cupping-score')) return;

    var text = desc.content;
    var scoreMatch = text.match(/(?:cupping\s*score|score)\s*[:\s]*(\d+\.?\d*)/i);
    if (!scoreMatch) return;
    var score = parseFloat(scoreMatch[1]);
    if (score < 80 || score > 100) return;

    var grade = score >= 90 ? 'Exceptional' : score >= 86 ? 'Excellent' : score >= 80 ? 'Specialty Grade' : '';
    var color = score >= 90 ? '#d4af37' : score >= 86 ? '#c08a4d' : '#1c6a4f';

    var display = document.createElement('div');
    display.className = 'hm-cupping-score';
    display.style.cssText = 'display:flex;align-items:center;gap:12px;padding:1rem;background:rgba(255,255,255,0.02);border-radius:10px;margin:0.5rem 0;border:1px solid rgba(212,175,55,0.1)';
    display.innerHTML = '<div style="font-size:2rem;font-weight:700;color:' + color + ';font-family:var(--font-heading-family,Assistant,sans-serif)">' + score + '</div><div><div style="color:#d4af37;font-weight:700;font-size:0.85rem">Cupping Score</div><div style="color:rgba(241,233,210,0.5);font-size:0.75rem">' + grade + '</div></div>';
    descEl.parentNode.insertBefore(display, descEl.nextSibling);
  };

  /* ============================================
     92. HOMEPAGE: RECENTLY VIEWED — DISABLED (P1)
     No value on first visit; keep in sidebar/drawer on product pages only.
     ============================================ */
  HM.injectHomepageRecent = function() {};

  /* ============================================
     93. PDP: ALTITUDE & VARIETAL INFO
     ============================================ */
  HM.injectAltitudeInfo = function() {
    var desc = document.querySelector('meta[property="og:description"]');
    if (!desc || !desc.content.toLowerCase().includes('coffee')) return;
    var descEl = document.querySelector('.product__description, .rte');
    if (!descEl || document.querySelector('.hm-altitude-info')) return;

    var text = desc.content;
    var info = [];

    var altMatch = text.match(/(\d{3,4})\s*(?:m|meters?|masl)/i);
    if (altMatch) info.push({ label: 'Altitude', value: altMatch[0] });

    var varietalMatch = text.match(/(caturra|bourbon|typica|geisha|sl28|sl34|catuai|pacamara|heirloom|tim-tim|catimor)/i);
    if (varietalMatch) info.push({ label: 'Varietal', value: varietalMatch[0] });

    var regionMatch = text.match(/(huila|tarrazu|kercha|aceh|yirgacheffe|sidamo|antigua|kona|sumatra|java)/i);
    if (regionMatch) info.push({ label: 'Region', value: regionMatch[0] });

    if (info.length === 0) return;
    var container = document.createElement('div');
    container.className = 'hm-altitude-info hm-coffee-attrs';
    container.innerHTML = '<h3 style="width:100%;color:#f1e9d2;font-size:0.9rem;margin:0 0 0.5rem;font-family:var(--font-heading-family,Assistant,sans-serif)">Coffee Details</h3>';
    info.forEach(function(i) {
      var attr = document.createElement('span');
      attr.className = 'hm-coffee-attr';
      attr.innerHTML = '\u2615 ' + i.label + ': ' + i.value;
      container.appendChild(attr);
    });
    descEl.parentNode.insertBefore(container, descEl.nextSibling);
  };

  /* ============================================
     94. PDP: ROAST DATE SIMULATOR
     ============================================ */
  HM.injectRoastDate = function() {
    var desc = document.querySelector('meta[property="og:description"]');
    if (!desc || !desc.content.toLowerCase().includes('coffee')) return;
    var form = document.querySelector('product-form, form[action*="/cart/add"]');
    if (!form || document.querySelector('.hm-roast-date')) return;

    var date = new Date();
    var roastDate = new Date(date.getTime() + 2 * 24 * 60 * 60 * 1000); // 2 days from now
    var dateStr = roastDate.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });

    var info = document.createElement('div');
    info.className = 'hm-roast-date';
    info.style.cssText = 'font-size:0.75rem;color:rgba(241,233,210,0.4);margin:0.3rem 0;padding:4px 8px;background:rgba(255,255,255,0.02);border-radius:6px';
    info.innerHTML = 'Estimated roast date: <span style="color:#d4af37;font-weight:600">' + dateStr + '</span> (roasted to order)';
    form.parentNode.insertBefore(info, form);
  };

  /* ============================================
     95. HOMEPAGE: TRUST PILOT STYLE REVIEWS SUMMARY — DISABLED (P1)
     Fake review summary with no real reviews. Merged into testimonials section.
     ============================================ */
  HM.injectReviewSummary = function() {};

  /* ============================================
     96. PDP: MINI FAQ (product-specific)
     ============================================ */
  HM.injectProductFAQ = function() {
    if (!window.location.pathname.includes('/products/')) return;
    var form = document.querySelector('product-form, form[action*="/cart/add"]');
    if (!form || document.querySelector('.hm-product-faq')) return;
    
    // Better coffee detection: check meta description, page title, URL handle, and product type
    var desc = document.querySelector('meta[property="og:description"]');
    var titleEl = document.querySelector('h1');
    var titleText = titleEl ? titleEl.textContent.toLowerCase() : '';
    var descText = desc ? desc.content.toLowerCase() : '';
    var path = window.location.pathname.toLowerCase();
    var isCoffee = descText.includes('coffee') || descText.includes('roast') || 
                   titleText.includes('coffee') || titleText.includes('roast') ||
                   titleText.includes('origin') || titleText.includes('blend') ||
                   path.includes('coffee') || path.includes('origin') || path.includes('blend') ||
                   path.includes('jaguar') || path.includes('caturra') || path.includes('tarrazu') ||
                   path.includes('anaerobic') || path.includes('monteblanco') || path.includes('ethiopia') ||
                   path.includes('sumatra') || path.includes('java') || path.includes('burundi') ||
                   path.includes('colombia') || path.includes('costa-rica') || path.includes('kercha') ||
                   path.includes('catturon') || path.includes('betulia') || path.includes('aceh') ||
                   path.includes('siki') || path.includes('rugembe') || path.includes('restorative') ||
                   path.includes('alien') || path.includes('lions-mane') || path.includes('shroom');

    var faqs = isCoffee ? [
      { q: 'How fresh is the coffee?', a: 'All coffee is roasted to order. Your beans will be roasted within 1-3 business days of ordering, ensuring maximum freshness.' },
      { q: 'How should I brew this?', a: 'Check our brewing guide above for recommended methods, ratios, and grind sizes specific to this coffee.' },
      { q: 'What is the shelf life?', a: 'Whole bean coffee stays fresh for 30+ days after roasting. Store in an airtight container away from light and heat.' },
      { q: 'What is your return policy?', a: 'If you are not satisfied with your coffee, contact us within 30 days of purchase. We will make it right with a replacement or refund.' }
    ] : [
      { q: 'When will my order ship?', a: 'Most orders ship within 1-3 business days. You will receive a tracking number once your order ships.' },
      { q: 'What is your return policy?', a: 'We accept returns within 30 days of purchase. Items must be unworn and in original condition.' },
      { q: 'Do you offer bulk or wholesale pricing?', a: 'Yes! Visit our White Label & Wholesale page for pricing on custom branded coffee, apparel, and merchandise.' }
    ];

    var section = document.createElement('div');
    section.className = 'hm-product-faq hm-pdp-section';
    var html = '<h3>Frequently Asked Questions</h3>';
    faqs.forEach(function(f) {
      html += '<div class="hm-faq-item"><div class="hm-faq-q">' + f.q + '</div><div class="hm-faq-a">' + f.a + '</div></div>';
    });
    section.innerHTML = html;
    form.parentNode.insertBefore(section, form.nextSibling);

    section.querySelectorAll('.hm-faq-q').forEach(function(q) {
      q.addEventListener('click', function() {
        var a = q.nextElementSibling;
        q.classList.toggle('open');
        a.classList.toggle('open');
      });
    });
  };

  /* ============================================
     98. NAV FIXES (P0)
     Fix misspelled "Shroomfee" → "Shroomffee", dead nav links, and 404 app page.
     These are in Shopify's navigation admin which our API token can't access,
     so we patch them client-side until the admin nav is updated.
     ============================================ */
  HM.fixNavigationP0 = function() {
    function fixLinks() {
      // Fix Shroomfee → Shroomffee in all text nodes
      document.querySelectorAll('a, span').forEach(function(el) {
        var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
        var node;
        while (node = walker.nextNode()) {
          if (node.textContent.includes('Shroomfee') && !node.textContent.includes('Shroomffee')) {
            node.textContent = node.textContent.replace(/Shroomfee(?!f)/g, 'Shroomffee');
          }
        }
        // Fix aria-labels
        if (el.getAttribute) {
          var al = el.getAttribute('aria-label');
          if (al && al.includes('Shroomfee') && !al.includes('Shroomffee')) {
            el.setAttribute('aria-label', al.replace(/Shroomfee(?!f)/g, 'Shroomffee'));
          }
        }
      });

      // Fix dead nav links
      document.querySelectorAll('a').forEach(function(a) {
        var text = a.textContent.trim().toLowerCase();
        var href = a.getAttribute('href') || '';

        // Apparel & Gear → link to all products
        if (text === 'apparel & gear' && (href === '/' || href === '')) {
          a.setAttribute('href', '/collections/all');
        }

        // Research → link to research page
        if (text === 'research' && (href === '/' || href === '')) {
          a.setAttribute('href', '/pages/lions-mane-research');
        }

        // App page 404 → hide link
        if (href.includes('app-coming-soon')) {
          a.style.display = 'none';
        }

        // P1: Rename "Order" → "Market Menu" in nav (distinguish from e-commerce)
        if (text === 'order' && href.includes('/pages/menu')) {
          node = a;
          // Walk text nodes to replace
          var walker2 = document.createTreeWalker(a, NodeFilter.SHOW_TEXT, null);
          var tn;
          while (tn = walker2.nextNode()) {
            if (tn.textContent.trim() === 'Order') {
              tn.textContent = 'Market Menu';
            }
          }
        }
      });
    }

    // Run immediately
    fixLinks();

    // Re-apply every 500ms for the first 10 seconds to catch any re-renders
    var attempts = 0;
    var interval = setInterval(function() {
      fixLinks();
      attempts++;
      if (attempts >= 20) clearInterval(interval);
    }, 500);
  };

  /* ============================================
     97. FINAL INIT (v5.1 additions)
     ============================================ */
  var origInit8 = HM.init;
  

  
  /* UNIFIED INIT - all enhancement functions */
  HM.init = function() {
    HM.fixNavigationP0();
    HM.injectAnnouncementBar();
    HM.injectTrustBar();
    HM.injectBrandStrip();
    HM.injectStatsBar();
    HM.injectCoffeeShowcase();
    HM.injectTestimonials();
    HM.injectFAQ();
    HM.injectNewsletter();
    HM.injectSocialFeed();
    HM.injectBackToTop();
    HM.injectBreadcrumbs();
    HM.initKeyboardShortcuts();
    HM.enhanceLazyLoad();
    HM.initPrefetchOnHover();
    HM.trackRecentlyViewed();
    HM.injectStickyATC();
    HM.injectSearchOverlay();
    HM.injectCartFreeShipping();
    HM.injectPDPTrust();
    HM.enhanceCoffeePDP();
    HM.injectCollectionSortBar();
    HM.enhanceProductCards();
    HM.initScrollAnimations();
    HM.injectRecentlyViewed();
    HM.injectRelatedProducts();
    HM.injectSizeGuide();
    HM.injectBrewingGuide();
    HM.injectStockIndicator();
    HM.injectViewCounter();
    HM.enhanceShopPay();
    HM.enhanceGalleryZoom();
    HM.injectCollectionFilters();
    HM.initInfiniteScroll();
    HM.injectMobileNav();
    HM.injectScrollProgress();
    HM.injectExitPopup();
    HM.injectCookieConsent();
    HM.injectFlavorWheel();
    HM.injectRoastMeter();
    HM.injectCartUpsell();
    HM.injectGiftCardPromo();
    HM.injectSeasonalBanner();
    HM.injectStructuredData();
    HM.preloadResources();
    HM.optimizeImages();
    HM.enhanceAccessibility();
    HM.injectCartBadge();
    HM.initWishlist();
    HM.initCompare();
    HM.initQuickView();
    HM.reorderHomepage();
    HM.enhanceCollectionHeader();
    HM.addProductCardBadges();
    HM.enhanceCartPage();
    HM.enhanceArticle();
    HM.enhanceFooter();
    HM.initPageLoader();
    HM.enhanceCollectionScroll();
    HM.injectProductTabs();
    HM.enhanceDarkMode();
    HM.initImageFadeIn();
    HM.initButtonLoading();
    HM.injectOriginMap();
    HM.injectSubPromo();
    HM.initImageMagnify();
    HM.injectRatingStars();
    HM.enhanceQuantitySelector();
    HM.enhanceVariantSelector();
    HM.injectBreadcrumbSchema();
    HM.injectCollectionSchema();
    HM.injectAvailabilitySchema();
    HM.injectCoffeeComparison();
    HM.initLongPressWishlist();
    HM.initRotatingAnnouncement();
    HM.updateCopyrightYear();
    HM.injectCoffeeEducation();
    HM.injectFreshnessIndicator();
    HM.injectPDPShare();
    HM.enhanceCollectionTitle();
    HM.injectCollectionCards();
    HM.injectProcessingInfo();
    HM.injectBestsellers();
    HM.injectBrewRecommendation();
    HM.injectCuppingScore();
    HM.injectHomepageRecent();
    HM.injectAltitudeInfo();
    HM.injectRoastDate();
    HM.injectReviewSummary();
    HM.injectProductFAQ();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        HM.enhanceProductCards();
        HM.initScrollAnimations();
        HM.injectRecentlyViewed();
      });
    } else {
      HM.enhanceProductCards();
      HM.initScrollAnimations();
      HM.injectRecentlyViewed();
    }

    setInterval(function() { HM.enhanceProductCards(); }, 3000);

    console.log('Harvest Market Enhancement System v9 initialized - all functions active');
  };

  if (window.location.hostname.includes("harvestmarket.coffee")) {
    HM.init();
  }
})();